import $ from "jquery"
import "slick-carousel"
import "jquery-waypoints/waypoints.js"
import "cropper"
import "canvas-to-blob"
import Vue from "vue";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import {createPopper} from "@popperjs/core";

(function($, t){

    t.controllers.define(
        'pet-gender',
        {
            'change input:radio': 'onButtonClick',
            'change input[type=checkbox]': 'onCheckboxClick'
        },
        {
            'init:after':  function() {
                this.$neutered = this.findWithinDOM('.neutered');
                this.$pregnantNursing = this.findWithinDOM('.pregnant-nursing');
                this._valuesChanged();
            },
            onButtonClick: function(e) {
                this._valuesChanged();
            },
            onCheckboxClick: function(e) {
                this._valuesChanged();
            },
            _valuesChanged: function () {
                if (this.findWithinDOM('input[type=radio]:checked').val() === 'male') {
                    this.$neutered.removeAttr('disabled');
                    this.$pregnantNursing.attr('disabled', true).parent();
                } else {
                    this.$pregnantNursing.removeAttr('disabled');
                    if (this.$pregnantNursing.not(':disabled').is(':checked')) {
                        this.$neutered.attr('disabled', true);
                    } else if (this.$neutered.not(':disabled').is(':checked')) {
                        this.$pregnantNursing.attr('disabled', true);
                    } else {
                        this.$pregnantNursing.removeAttr('disabled');
                        this.$neutered.removeAttr('disabled');
                    }
                }
            }
        }
    );

    t.controllers.define(
        'main',
        {
            'click .link.new-pet': 'onAddPetClick'
        },
        {
            onAddPetClick: function (e) {
                var newPet = this.$el.find(".section.new-pet");

                newPet.toggleClass("show");

                $('html, body').animate({ scrollTop: newPet.position().top });

                e.preventDefault();
            }
        }
    );

    t.controllers.define(
        'category-scroller',
        {
        },
        {
            'init:after': function () {
                this.$el.addClass("slick");
                this.$el.find('.categories').slick({
                    infinite: true,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    nextArrow: this.$el.find(".button.next"),
                    prevArrow: this.$el.find(".button.previous"),
                    swipeToSlide: true,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 0
                            }
                        },
                        {
                            breakpoint: 850,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }
        }
    );

    t.controllers.define(
        'pet-sticky-header',
        {},
        {
            'init:after': function() {
                t.message.subscribe('sticky-header', 'update', t.util.bind(this.update, this));
                this.sticky_header = this.$el;
                this.show = $(this.$el.attr("data-show"));
                this.hide = $(this.$el.attr("data-hide"));
                this.initWaypoint();
            },
            initWaypoint: function () {
                var that = this;
                this.show.waypoint({
                    handler: function (direction) {
                        that.sticky_header.toggleClass("show", direction == "down");
                    }
                });
                this.hide.waypoint({
                    handler: function (direction) {
                        that.sticky_header.toggleClass("passed", direction == "down");
                    },
                    offset: 100
                });
            },
            update: function(e) {
                var data = e['data'];
                this.$el.find(".name").text(data['name']);
                this.$el.find(".roundal").replaceWith(data['roundal']);
            }
        }
    );

    t.controllers.define(
        'account-banner',
        {
            'click .dashboard-tell-more': 'sendOptimizelyEvent'
        },
        {
            'init:after': function () {

            },
            sendOptimizelyEvent: function (e) {
                this.optimizelyTrackApi('banner_clicked_on_dashboard_page');
            },
            optimizelyTrackApi: function (event) {
                $.ajax({
                    type: 'GET',
                    url: '/api/optimizely/track/?event=' + event,
                    dataType: 'json',
                    success: (response) => {},
                });
            }
        }
    );

    t.controllers.define(
        'pet-profiles',
        {
            "click .next-pet": "updateStickyHeader",
            "click .prev-pet": "updateStickyHeader",
            'click .delivery-confirmation .btn': 'clickConfirmButton',
        },
        {
            'init:after': function() {
                this.initSlick();
                this.hash = this.$el.attr("data-hash");
                this.setActiveDot();
                this.repositionNotifications();
            },
            clickConfirmButton: function(e) {
                var el = $(e.currentTarget);

                if (el.hasClass('btn-no')) {
                    $('.delivery-confirmation .question').hide();
                    $('.delivery-confirmation .confirmed-no').toggleClass('hidden');
                    return false;
                } else {
                    $.ajax({
                        type: 'POST',
                        url: el.closest('form').attr('action'),
                        cache: false,
                        contentType: false,
                        processData: false,
                        complete: function (response, status) {
                            if (response && response.responseJSON.result) {
                                $('.delivery-confirmation .question').hide();
                                $('.delivery-confirmation .confirmed-yes').toggleClass('hidden');
                            } else {
                                $('.delivery-confirmation .question .message').toggleClass('hidden');
                            }
                        },
                    });
                    return false;
                }
            },
            getSlideIndexForPetId: function(id) {
                var targetSlide = this.$el.find('[data-pet_id]').filter(function(i, x) {
                    return $(x).data('pet_id') == id;
                }).first();

                if(targetSlide.length > 0) {
                    return targetSlide.first().index();
                }
                else {
                    return null;
                }
            },
            initSlick: function() {
                var that = this;
                if(this.$el.attr("data-length") == 1) {
                    return;
                }

                var pet_id = window.location.hash.replace("#", "");
                var index = 0;

                if(pet_id) {
                    var targetSlideIndex = this.getSlideIndexForPetId(pet_id);
                    if(targetSlideIndex !== null) {
                        index = targetSlideIndex;
                    }
                }
                this.$el.slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    nextArrow: this.$el.find(".next-pet"),
                    prevArrow: this.$el.find(".prev-pet"),
                    initialSlide: index,
                    mobileFirst: true,
                    touchThreshold: 10,
                    swipe: true,
                    responsive: [{
                      breakpoint: 1024,
                      settings: {
                          touchMove: true
                      }
                    }],
                    touchMove: false,
                    appendDots: '.slick-dots-holder',
                }).on({
                    'setPosition': t.util.bind(this.moveDots, this),
                    'afterChange': function (e, slick, direction) {
                        that.updateStickyHeader();
                        that.setActiveDot();
                        that.repositionNotifications();
                    }
                });
                // Wait for a little bit so the sticky header handler will have loaded in
                setTimeout(function () {
                    that.updateStickyHeader();
                }, 1000);
            },
            moveDots: function() {
            },
            updateStickyHeader: function() {
                var slick = this.$el.slick("getSlick");
                var slide = $(slick.$slides[slick.currentSlide]);

                var pet_roundal = slide.find('.roundal').clone();
                pet_roundal.find(".action").remove();

                var name = slide.attr("data-name");
                var pet_id = slide.attr("data-pet_id");

                t.message.publish('sticky-header', 'update', {
                    'name': name,
                    'roundal': pet_roundal
                });

                if(slick.currentSlide === 0) {
                    if(this.getSlideIndexForPetId(window.location.hash.replace(/^#/, '')) !== null) {
                        window.location.hash = '';
                    }
                }
                else {
                    window.location.hash = pet_id;
                }
            },
            setActiveDot: function() {
                const currentIndex = document.querySelector('.slick-current').dataset.slickIndex;
                if (currentIndex) {
                    const activeDot = document.querySelectorAll('.slick-current li button')[currentIndex];
                    if (activeDot) {
                        activeDot.classList.add('active');
                    }
                }
            },
            repositionNotifications: function() {
                const petProfiles = document.getElementsByClassName('profile-wrapper');
                if (petProfiles !== undefined) {
                    petProfiles.forEach(function(element) {
                        const profileBottomContainer = element.getElementsByClassName('profile-bottom')[0];
                        const hasNotification = element.querySelectorAll('.notification');
                        if ((hasNotification !== null) && (hasNotification.length > 0)) {
                            profileBottomContainer.classList.add('has-notification');
                        }
                    });
                }
            }
        }
    );
    t.controllers.define(
        'signed-in-pet-weight',
        {
            'change .form-control': "convertToDecimal",
        },
        {
            convertToDecimal: function(e) {
                e.target.value = (parseFloat(e.target.value.replace(',', '.') || 0));
            }
        }
    );
    t.controllers.define(
        'new-pet',
        {
        },
        {
            'init:after': function() {
                if(window.location.hash === '#add-dog') {
                    $(window).on('load', function() {
                        $('.link.new-pet').trigger('click');
                    });
                }
            }
        }
    );

    t.controllers.define(
        'shipment-details',
        {
            'click a.add-scoop-toggle': 'showPopup',
            'click a.opening-hours-btn': 'showOpeningHours',
        },
        {
            showPopup: function(e) {
                t.message.publish('auto-popup', 'show-add-scoop-popup')
            },
            // Expand a link into a list of opening hours and hide the link
            showOpeningHours: function () {
                const openingHoursURL = '/api/gfs/collection-point';
                const openingHoursDisplay = this.$el.find('.opening-hours');
                const openingHoursBtn = this.$el.find('.opening-hours-btn');
                const shopID = this.$el.find('[data-shop-id]').attr('data-shop-id');
                fetch(`${openingHoursURL}/${shopID}`)
                    .then(resp => resp.json())
                    .then(data => {
                        let hoursHTML = '';
                        const openingHours = data.opening_hours;
                        for (const index in openingHours) {
                            const day = Object.keys(openingHours[index])[0];
                            if (!day) continue;
                            const hours = Object.values(openingHours[index]).join(', ');
                            hoursHTML += `<p>${day}: ${hours}</p>`;
                        }
                        openingHoursBtn.hide();
                        openingHoursDisplay.html(`${hoursHTML}`);
                    });
            }
        }
    );

    t.controllers.define(
        'sca-explainer',
        {
            'click a.sca-explainer-link': 'showScaExplainer'
        },
        {
            'init:after': function () {
                this.text = this.findWithinDOM('.sca-explainer-text');
                this.link = this.findWithinDOM('.sca-explainer-link');
            },
            showScaExplainer: function (e) {
                e.preventDefault();
                this.text.removeClass('hide');
                this.link.addClass('hide');
            }
        }
    );

    t.controllers.define(
        'deliveries-calendar',
        {
            'click td.marked': 'cellClicked',
            'click .calendar-cell': 'cellClicked',
            'click .prev': 'selectPrev',
            'click .next': 'selectNext',
            'click .for-pets .roundal': 'petRoundalClicked'
        },
        {
            "init:after": function () {
                this.single_line = this.$el.find(".single-line-calendar");
                this.slider = this.single_line.find(".slider");
                this.focusSelected();

                this.selected_shipment = null;
                this.shipments_data = JSON.parse(this.$el.find(".shipments-data").html());
                this.shipments = this.shipments_data['future_shipments'];
                this.date_map = this.shipments_data['date_map'];
                this.markDates();
                this.selectShipment(this.shipments[0]['index']);
            },
            markDates: function () {
                for(var date in this.date_map) {
                    this.$el.find("td[data-date=" + date + "]").addClass("marked");
                    this.single_line.find(".calendar-cell[data-date=" + date + "] .day").addClass("marked");
                }
            },
            petRoundalClicked: function (e) {
                var shipment = $(e.target).attr("data-shipment");
                this.selectShipment(shipment);
            },
            focusSelected: function () {
                var selected_doms = this.single_line.find(".calendar-cell .day.payment");
                if(selected_doms.length == 0) {
                    return;
                }
                var first_selected = $(selected_doms[0]);
                //var last_selected = $(selected_doms[selected_doms.length - 1]);

                var selected_width = 0;
                $.each(selected_doms, function(i, v) {
                    selected_width += $(v).outerWidth();
                });

                // Focus on first day of delivery window if range too big
                if(selected_width > this.single_line.innerWidth()) {
                    first_selected = $(selected_doms[1]);
                }

                var offset_left = first_selected.position().left;
                var offset = this.slider.offset().left - offset_left;
                this.slider.css("margin-left", offset);
            },
            cellClicked: function (e) {
                var target = $(e.currentTarget);
                var date = target.attr("data-date");
                if(!date || this.date_map[date] == undefined){
                    return;
                }
                var shipment_indexes = this.date_map[date];
                var other_shipments = shipment_indexes.length > 1;
                var index = shipment_indexes.indexOf(this.selected_index);
                var same_shipment = index != -1;
                if(!same_shipment) {
                    this.selectShipment(this.date_map[date][0]);
                }
                else if(other_shipments) {
                    index += 1;
                    index = index >= shipment_indexes.length ? 0 : index;
                    this.selectShipment(this.date_map[date][index]);
                }
            },
            selectNext: function () {
                this.shiftSelection(1);
            },
            selectPrev: function () {
                this.shiftSelection(-1);
            },
            shiftSelection: function (shift) {
                var next_shipment = this.shipments[this.shipments.indexOf(this.selected_shipment) + shift];

                if(!next_shipment) {
                    if(shift == 1) {
                        next_shipment = this.shipments[0];
                    }
                    else {
                        next_shipment = this.shipments[this.shipments.length - 1];
                    }
                }
                this.selectShipment(next_shipment['index']);
            },
            getShipmentByIndex: function(index) {
                return $.grep(this.shipments, function(item) {
                    return item['index'] == index;
                })[0];
            },
            highlightDate: function (date, flag) {
                var indexes = this.date_map[date];
                var date_cell = this.$el.find("td[data-date=" + date + "], .calendar-cell[data-date=" + date + "] .day");
                date_cell.addClass(flag);
                if(indexes.length > 1) {
                    date_cell.addClass("other-shipments");
                }
            },
            selectShipment: function (index) {
                var shipment = this.getShipmentByIndex(index);
                this.selected_shipment = shipment;
                this.selected_index = index;
                this.$el.find("td").removeClass("payment delivery other-shipments");
                this.single_line.find(".calendar-cell .day").removeClass("payment delivery other-shipments");

                this.highlightDate(shipment['payment_date'], "payment");
                for(var i = 0; i < shipment['delivery_range'].length; i++) {
                    var date = shipment['delivery_range'][i];
                    this.highlightDate(date, "delivery");
                }

                var header = this.single_line.find(".calendar-cell[data-date='" + date + "']").attr("data-header");
                this.single_line.find(".month-name").text(header);

                $('.next-delivery.selected').removeClass("selected");
                $('.next-delivery[data-shipment=' + shipment['index'] + ']').addClass("selected");
                this.focusSelected();

                var dom_index = this.$el.find(".next-delivery.selected").index();
                var offset = 0 - (dom_index) * 100;
                this.$el.find(".delivery-details .slider").attr("style", "transform:translate(" + offset +"%);");
            }
        }
    );

    t.controllers.define(
        'pet-breed',
        {
            'click a.add-breed': 'onAddBreedClick',
            'click button.remove-breed': 'onRemoveBreedClick',
            'change select[data-select-type="breed"]': 'disableContinueIfEmpty'
        },
        {
            'init:after': function() {
                this._index = 0;
                this.$breeds = this.findWithinDOM('.breeds');

                this.$breeds.find('.breed').each(t.util.bind(function() {
                    this._index++;
                }, this));

                if (this.$breeds.find('.breed').length > 1) {
                    this.$breeds.find('.remove-breed').removeClass('invisible');
                }
            },
            disableContinueIfEmpty: function() {
                const selectedOptions = this.$breeds.find('[data-select-type="breed"]')
                const submitButton = $('#updateBreedsSubmit')
                if (selectedOptions.toArray().every(el => el.value === undefined || el.value === null || el.value === '')) {
                    submitButton.prop('disabled', true);
                } else {
                    submitButton.prop('disabled', false);
                }
            },
            addNewBreed: function(index) {
                var $newBreed = this.findWithinDOM('.breed').first().clone();

                var nameRoot = /^(.+?)-\d+$/.exec($newBreed.find('select').attr('name'))[1];
                $newBreed.find('select').val([]).attr('name', nameRoot+'-'+index).removeProp('disabled').focus();

                $newBreed.appendTo(this.$breeds);

                // enable all remove buttons now we have more than one input
                if (this.$breeds.find('.breed').length > 1) {
                    this.$breeds.find('.remove-breed').removeClass('invisible');
                }
            },
            onRemoveBreedClick: function(e) {
                var $target = $(e.target);

                e.preventDefault();

                if (this.$breeds.find('.breed').length <= 1) {
                    return;
                }

                $target.closest('.breed').remove();

                if (this.$breeds.find('.breed').length === 1) {
                    this.$breeds.find('.remove-breed').addClass('invisible');
                }

                this.disableContinueIfEmpty();
            },
            onAddBreedClick: function(e) {
                // clone the first field
                this.addNewBreed(this._index++);
                e.preventDefault();

                this.disableContinueIfEmpty();
            }
        }
    );

    t.controllers.define(
        'nested-checklist',
        {
            'click input[type=checkbox]': 'onCheckboxClick'
        },
        {
            onCheckboxClick: function(e) {
                const body = document.querySelector('body');
                var $target = $(e.target);
                if($target.data('single-only')) {
                    this.checkForSingleReason($target);
                }

                if ($target.siblings('ul').length > 0) {
                    if ($target.is(':checked')) {
                        $target.siblings('ul').slideDown('fast');
                    } else {
                        $target.siblings('ul').slideUp('fast');
                    }
                }

                if ($target.is(':checked')) {
                    $target.siblings('.form-group').slideDown('fast');
                } else {
                    $target.siblings('.form-group').slideUp('fast');
                }
            },
            checkForSingleReason(element) {
                const checked = $(element).is(':checked');
                const primaryCheckboxes = this.$el.find('[data-main-reason="true"]').toArray();
                const secondaryBoxes = this.$el.find('[data-main-reason="false"]').toArray();
                secondaryBoxes.forEach(box => box.addEventListener('change', () => {
                    secondaryBoxes.map(b => b.disabled = box.checked);
                    box.disabled = false;
                }));
                primaryCheckboxes.map(box => {
                    box.disabled = checked;
                });
                $(element).attr('disabled', false);
            }
        }
    );

    t.controllers.define(
        'fyf-main',
        {
            'click .btn-expand': 'onExpandClick',
            'click .btn-collapse': 'onCollapseClick'
        },
        {
            onExpandClick: function(e) {
                e.preventDefault();

                $(e.target).closest('.col').removeClass('collapsed');
            },
            onCollapseClick: function(e) {
                e.preventDefault();

                $(e.target).closest('.col').addClass('collapsed');
            }
        }
    );


    t.controllers.define(
        'fyf-faqs',
        {
            'click dt': 'onDefinitionClick'
        },
        {
            'init:after': function() {
                this.$el.find('dd').hide().css({'visibility': 'visible'});
            },
            onDefinitionClick: function(e) {
                $(e.target).toggleClass('open').next('dd').slideToggle('fast');
            }
        }
    );

    t.controllers.define(
        'weight-change',
        {
            'click .change-weight': 'onChangeWeightClick'
        },
        {
            'init:after': function() {
                this.$weightError = this.findWithinDOM('.weight-error');
            },
            onChangeWeightClick: function(e) {
                e.preventDefault();

                this.$el.find('.signed-in-pet-weight-input-group input').focus();

                this.$weightError.slideUp('fast');
            }
        }
    );

    t.controllers.define(
        'shop-pet-selector',
        {
            'click .dropdown span': 'onLabelClick'
        },
        {
            'init:after': function() {
                this.$dropdown = this.$el.find('.dropdown');
            },
            onLabelClick: function(e) {
                e.preventDefault();
                this.$dropdown.toggleClass('active');
            }
        }
    );

    t.controllers.define(
        'selection-method-toggle',
        {
            'click .btn': 'onModeButtonClick'
        },
        {
            'onModeButtonClick': function(e) {
                var mode = $(e.currentTarget).data('mode');
                this.$el.find('#selection_method').val(mode);
                this.toggle(mode);
            },
            'toggle': function(mode) {
                this.$el.attr("data-mode", mode);
                t.message.publish('shop-selection-mode', 'change', {
                    'mode': mode
                });
            }
        }
    );

    t.controllers.define(
        'shop-tray-size-selector',
        {
            'click input': 'onToggleChange'
        },
        {
            'init:after': function() {
                this._selectedTraySize = this.$el.find('input:checked').attr('value');
                t.message.subscribe('shop', 'selection-change', t.util.bind(this.onShopSelectionChange, this));
            },
            'onShopSelectionChange': function(e) {
                this.options.numTraysSelected = e.data.totalQuantity;
            },
            'onToggleChange': function(e) {
                var _changeTraySize = t.util.bind(function() {
                    this._selectedTraySize = this.$el.find('input:checked').attr('value');
                    var $form = this.$el.find('form');
                    this.$el.addClass('loading');
                    $.post(
                        $form.attr('action'), $form.serialize()
                    ).success(
                        t.util.bind(function(data) {
                            t.message.publish('shop-tray-size-selector', 'change', {
                                traysPerOrder: data.trays_per_order,
                                selectedTraySize: this._selectedTraySize,
                                trayFraction: data.tray_fraction,
                            });
                            this.$el.removeClass('loading');
                        }, this)
                    );
                }, this);

                if (this.options.numTraysSelected > 0) {
                    this.tray_size_alert = this.$el.find(".tray-size-alert");
                    t.ui.alert.show(
                        'Warning',
                        '',
                        this.tray_size_alert.html(),
                        [
                            t.ui.alert.BUTTON_CANCEL,
                            t.ui.alert.BUTTON_YES
                        ],
                        t.util.bind(function(button) {
                            window.dataLayer.push({
                                event: 'ga',
                                eventCategory: 'wet-food-shop',
                                eventAction: 'tray-size-toggle',
                                eventLabel: 'confirm-' + button
                            });
                            if (button === t.ui.alert.BUTTON_YES) {
                                _changeTraySize();
                            } else {
                                this.$el.find('input[value=' + this._selectedTraySize + ']').prop('checked', true);
                            }
                        }, this)
                    );
                } else {
                    _changeTraySize();
                }
            }
        }
    );

    t.controllers.define(
        'shop-recommended-amount',
        {
            'init:after': function() {
                t.message.subscribe('shop-tray-size-selector', 'change', t.util.bind(this.onTraySizeChange, this));
            },
            onTraySizeChange: function(e) {
                this.$el.find('.trays-per-order').text(e.data.traysPerOrder);
                this.$el.find('.tray-size').text(`${e.data.selectedTraySize}g`);
                this.$el.find('.tray-fraction').html(e.data.trayFraction);
            }
        }
    );

    t.controllers.define(
        'shop-utility-bar',
        {
            'click button.filter': 'onFilterButtonClick',
            'change input[type=checkbox]': 'onFilterInputChange',
            'click button.checkout': 'onCheckoutButtonClick',
            'click button.back': 'onBackButtonClick',
            'click button.order-wet-food': 'onOrderButtonClick',
            'click a.empty': 'onEmptyClick',
            'click .accordion-title-flavours': 'onAccordionFlav',
            'click .accordion-title-textures': 'onAccordionText',
            'click .accordion-title-ranges': 'onAccordionRang',
            'click .filter-drawer .filter-drawer-title': 'closeFilterDrawer',
            'click .cart .outer-filter-drawer': 'closeFilterDrawerFromOutsideFilter',
            'click .range-select': 'onRangeSelect',
        },
        {
            'init:after': function() {
                this.$filterDrawer = this.$el.find('.filter-drawer');
                this.$outerFilterDrawer = this.$el.find('.outer-filter-drawer');
                this.$selectedCount = this.$el.find('.selected');
                this.$totalCount = this.$el.find('.total');
                this.$selectedPrice = this.$el.find('.selected-price .price');
                this.$limit = this.$el.data("limit");
                this.$limit_message = this.$el.data("limit-message");
                this.$traySelector = $(document.getElementById('tray-size-selector'))
                this.$filtersButtonDiv = this.$el.find('.filters');

                this.$locale = this.$el.data('locale').replace("_", "-");
                this.$currency = this.$el.data('currency');

                this.$limit_reached = this.$selectedCount === this.$limit;
                t.message.subscribe('shop-tray-size-selector', 'change', t.util.bind(this.onTraySizeChange, this));
                t.message.subscribe('shop', 'selection-change', t.util.bind(this.onShopSelectionChange, this));
                t.message.subscribe('shop-selection-mode', 'change', t.util.bind(this.onSelectionModeChange, this));
                t.message.subscribe('shop', 'state', t.util.bind(function(e) {
                    this.setState(e['data'])
                }, this));
                t.message.subscribe('filter-trays-count', 'change', t.util.bind(this.changeTraysCount, this))

                // Fix scroll
                var $container = this.$el.parent();

                $container.waypoint({
                    handler: t.util.bind(function(direction){
                        if (direction === "down") {
                            this.$el.addClass('fixed');
                            $container.css('height', this.$el.outerHeight() + 'px');
                        } else {
                            this.$el.removeClass('fixed');
                            $container.css('height', 'auto');
                        }
                    }, this),
                    offset: $('.top-nav').outerHeight()
                });
                this.filterState = {};
                this.traySizeChanged = false;
            },
            onEmptyClick: function(e) {
                if (this.options.numTraysSelected > 0) {
                    this.empty_basket_alert = $(".empty-basket-alert");
                    t.ui.alert.show(
                        'Warning',
                        '',
                        this.empty_basket_alert.html(),
                        [
                            t.ui.alert.BUTTON_CANCEL,
                            t.ui.alert.BUTTON_YES
                        ],
                        function (clicked) {
                            if (clicked === t.ui.alert.BUTTON_YES) {
                                window.dataLayer.push({
                                    event: 'ga',
                                    eventCategory: 'wet-food-shop',
                                    eventAction: 'selection',
                                    eventLabel: 'empty'
                                });
                                t.message.publish('shop-product', 'clear');
                            }
                        }
                    );
                }
            },
            onSelectionModeChange: function(e) {
                var mode = e['data']['mode'];
                this.$el.attr("data-mode", mode);
                this.setState('cart');
                this.setMode(mode);
            },
            onTraySizeChange: function(e) {
                this.setState('cart');
                this.options.traysPerOrder = e.data.traysPerOrder;
                this.$totalCount.text(e.data.traysPerOrder);
                this.traySizeChanged = true;
                this.onFilterInputChange()
                this.traySizeChanged = false;
            },
            onShopSelectionChange: function(e) {
                if(e.data.totalQuantity >= this.$limit) {
                    this.$limit_reached = true;
                    t.message.publish('shop-product', 'disable', this.$limit_message);
                }
                else if (this.$limit_reached) {
                    t.message.publish('shop-product', 'enable');
                }
                if (e.data.totalQuantity > this.$limit) {
                    return;
                }
                this.options.numTraysSelected = e.data.totalQuantity;
                this.$selectedCount.text(e.data.totalQuantity);

                var totalPrice = e.data.totalPrice;
                var discount = this.$selectedPrice.data("discount");
                if (discount && discount > 0) {
                    totalPrice = totalPrice - (totalPrice * (discount / 100));
                }

                const decimal_price = (totalPrice / 100).toFixed(2);
                const formatted_price = new Intl.NumberFormat(this.$locale, {
                    style: 'currency',
                    currency: this.$currency
                }).format(decimal_price);

                totalPrice = totalPrice > 0 || e.data.totalQuantity === 0 ? formatted_price : "Free";

                this.$selectedPrice.html(totalPrice);
                var wrapper = this.$selectedCount.parent();
                if(wrapper.hasClass("pop")){
                    wrapper.removeClass("pop").addClass("pop2");
                }
                else {
                    wrapper.removeClass("pop2").addClass("pop");
                }
            },
            onFilterButtonClick: function(e) {
                e.preventDefault();
                document.body.style.overflow = "hidden";
                this.toggleFilterDrawer();
            },
            onCheckoutButtonClick: function(e) {
                e.preventDefault();
                this.setState('checkout');
            },
            onBackButtonClick: function(e) {
                e.preventDefault();
                this.setState('cart');
            },
            onOrderButtonClick: function(e) {
                e.preventDefault();
                var traysPerOrder = this.options.traysPerOrder;
                var numTraysSelected = this.options.numTraysSelected;
                var messagesHighTrays = $(".highTrays-alert");
                var messagesLowTrays = $(".lowTrays-alert");
                messagesHighTrays.find('.trays-per-order').text(this.options.traysPerOrder)
                messagesLowTrays.find('.trays-per-order').text(this.options.traysPerOrder)
                var selectedMessage;
                if (traysPerOrder !== numTraysSelected) {
                    selectedMessage = numTraysSelected < traysPerOrder ? messagesLowTrays : messagesHighTrays;
                     t.ui.alert.show(
                        'Warning',
                        '',
                        selectedMessage.html(),
                        [
                            t.ui.alert.BUTTON_NO,
                            t.ui.alert.BUTTON_YES
                        ],
                        function(clicked) {
                            if (clicked === t.ui.alert.BUTTON_YES) {
                                $('form[name="wetfood-shop"]').submit();
                            }

                            if (clicked === t.ui.alert.BUTTON_NO) {
                                $("button.order").removeClass('btn-progress');
                            }
                        }
                    );
                }
                else {
                    $('form[name="wetfood-shop"]').submit();
                }


            },
            toggleFilterDrawer: function() {
                this.$filterDrawer.toggleClass('open');
                this.$outerFilterDrawer.toggleClass('open');
            },
            closeFilterDrawer: function() {
                this.$filterDrawer.removeClass('open');
                this.$outerFilterDrawer.removeClass('open');
                document.body.style.overflow = "auto";
            },
            _getFilter: function() {
                var filter = {};

                // Filters are true (show matching product) if the filter checkbox is checked or if in checkout mode
                var state = this.$el.attr('data-state');
                var mode = this.$el.attr('data-mode');
                var hide_unselected = state === 'checkout' || mode === 'automatic';

                this.$el.find('input[type=checkbox]').each(function(_, el) {
                    var $el = $(el);
                    filter[$el.attr('value')] = (
                        hide_unselected
                        || $el.is(':checked')
                        || $el.data('checked-before-range-change') === true
                    );
                });

                // Zero quantity items are not displayed in checkout mode
                filter.zeroQuantity = hide_unselected === false;
                filter.traySizeChanged = this.traySizeChanged;
                return filter;
            },
            onFilterInputChange: function() {
                this.filterState = this._getFilter()
                t.message.publish(
                    'shop-product-list-filter',
                    'change',
                    {
                        filter: this.filterState
                    }
                );
            },
            setMode: function(mode) {
                this.$el.attr("data-mode", mode);
            },
            setState: function(state) {
                // Change visual state
                this.$el.toggleClass('checkout', state === 'checkout');
                this.$traySelector.toggleClass('checkout', state === 'checkout');
                this.$filtersButtonDiv.toggleClass('checkout', state === 'checkout');
                // Scroll to top of product list if switching to checkout mode.
                if (state === 'checkout') {
                    $('html,body').animate({
                        'scrollTop': this.$el.parent().offset().top - $('.top-nav').outerHeight() - 1
                    }, 300);
                }

                // Reapply product filter to filter in/out zero quantity items
                t.message.publish(
                    'shop-product-list-filter',
                    'change', {
                        filter: this._getFilter()
                    }
                );
            },
            onAccordionFlav: function () {
                this.$el.find('.accordion-content-flavours').toggle(); // hide, show
                this.$el.find('.icon-flavours-open').toggle();
                this.$el.find('.icon-flavours-close').toggle();
            },
            onAccordionText: function () {
                this.$el.find('.accordion-content-textures').toggle(); // hide, show
                this.$el.find('.icon-textures-open').toggle();
                this.$el.find('.icon-textures-close').toggle();
            },
            onAccordionRang: function () {
                this.$el.find('.accordion-content-ranges').toggle(); // hide, show
                this.$el.find('.icon-ranges-open').toggle();
                this.$el.find('.icon-ranges-close').toggle();
            },
            closeFilterDrawerFromOutsideFilter: function (e) {
              if (e.target.classList.contains('outer-filter-drawer')) {
                this.closeFilterDrawer();
               }
            },
            changeTraysCount: function(e) {
                const traysCount = e.data.traysCount;
                let filterLiEls = this.$el.find('.checkbox-wrapper-alt-accordion-filter');
                filterLiEls.each((_, filterLiEl) => {
                        let $inputTag =  $($(filterLiEl).children()[0]);
                        const inputValue = $inputTag.val();
                        filterLiEl.children[1].children[0].innerHTML = `(${typeof traysCount[inputValue] != 'undefined' ? traysCount[inputValue] : 0})`;
                        if (parseInt(traysCount[inputValue]) > 0) {
                            $inputTag.prop(
                                'checked',
                                this.filterState[inputValue] || $inputTag.data(
                                    'checked-before-range-change'
                                )
                                );
                            $inputTag.removeData('checked-before-range-change')
                            $inputTag.prop('disabled', false);
                        } else {
                            if (this.filterState[inputValue]){
                                $inputTag.data('checked-before-range-change', true)
                            }
                            $inputTag.prop('checked',false);
                            $inputTag.prop('disabled', true);
                        }
                    }
                )
            },
            onRangeSelect: function(e) {
                let ranges = [];
                this.$el.find('.ranges-input-elem').each(function (_, elem) {
                        if (elem.checked) {
                        ranges.push(elem.value);
                    }
                });
                if (ranges.length === 0) {
                    e.preventDefault();
                }
            }
        }
    );
    t.controllers.define(
        'shop-product-list',
        {
            'click .accordion-excluded-recipes .accordion-title': 'onExcludedRecipesToggleClick',
            'shop-product:input-panel:show': 'onProductInputPanelShow',
            'shop-product:details:show': 'onProductDetailsShow',
            'shop-product:details:hide': 'onProductDetailsHide'
        },
        {
            'init:after': function() {
                this.$viewExcludedRecipesAccordion = this.$el.find('.accordion-excluded-recipes .accordion-title.view-excluded');
                this.$hideExcludedRecipesAccordion = this.$el.find('.accordion-excluded-recipes .accordion-title.hide-excluded');
                this.$emptyBasketMessage = this.$el.find(".message.empty");

                t.message.subscribe('shop-tray-size-selector', 'change', t.util.bind(this.onTraySizeChange, this));
                t.message.subscribe('shop-selection-mode', 'change', t.util.bind(this.onSelectionModeChange, this));
                t.message.subscribe('shop-product-list-filter', 'change', t.util.bind(this.onProductListFilterChange, this));
                t.message.subscribe('shop-product', 'change', t.util.bind(this.onProductChange, this));

                this.$preselectedQuantity = this.$el.data('quantity');
                if(this.$preselectedQuantity) {
                    this.selectRecommendation(this.$preselectedQuantity);
                }

                // If there are suitability warnings, show them in an alert modal
                this.suitability_alert = this.$el.find(".suitability-alert");
                if(this.suitability_alert.length > 0) {
                    t.ui.alert.show(
                        t.ui.alert.LEVEL_WARNING,
                        'Warning',
                        this.suitability_alert.html(),
                        [
                            t.ui.alert.BUTTON_CANCEL,
                            t.ui.alert.BUTTON_OK
                        ],
                        t.util.bind(function(button) {
                            if(button === t.ui.alert.BUTTON_CANCEL) {
                                window.location.href = this.suitability_alert.data("cancel-url");
                            }
                        }, this)
                    );
                }
                this.originalRangeFiltersState = {'premium': true, 'classic': true};
                this.trayCountsByRanges = this.collectTraysCount();
                this.allExcludedProductsFiltered = false;
            },
            onExcludedRecipesToggleClick: function(e) {
                var shouldShowExcludedRecipes = this.$el.hasClass('show-excluded-recipes') === false;
                if (shouldShowExcludedRecipes) {
                    this.showExcludedRecipes();
                } else {
                    this.hideExcludedRecipes();
                }
            },
            showExcludedRecipes: function() {
                this.$el.addClass('show-excluded-recipes');
                this.$viewExcludedRecipesAccordion.toggleClass('hidden');
                this.$hideExcludedRecipesAccordion.toggleClass('hidden');
            },
            hideExcludedRecipes: function() {
                this.$el.removeClass('show-excluded-recipes');
                this.$viewExcludedRecipesAccordion.toggleClass('hidden');
                this.$hideExcludedRecipesAccordion.toggleClass('hidden');
            },
            onSelectionModeChange: function(e) {
                var mode = e['data']['mode'];
                this.$el.attr('data-mode', mode);
                this.reload();
            },
            onTraySizeChange: function(e) {
                this.reload();
            },
            onProductChange: function(e) {
                this._updateDisplay();
            },
            onProductListFilterChange: function(e) {
                this._filter = e.data.filter;
                t.controllers.find(this.$el, 'shop-product').forEach(function(product) {
                    product.hideInputPanel();
                    product.hideDetails();
                });

                this._updateDisplay();
            },
            onProductInputPanelShow: function(e) {
                // Close any open input panels
                t.controllers.find(this.$el, 'shop-product').forEach(function(product) {
                    product.hideInputPanel();
                });
            },
            onProductDetailsShow: function(e) {
                var foundInputPanelOpen = false;

                // Close any open input and panels and details
                t.controllers.find(this.$el, 'shop-product').forEach(function(product) {
                    if (product.isInputPanelOpen()) {
                        foundInputPanelOpen = true;
                        product.hideInputPanel();
                    }

                    product.hideDetails();
                });

                // Cancel opening details panel if the user was just trying to close the input panel
                if (foundInputPanelOpen) {
                    e.preventDefault();
                }
            },
            onProductDetailsHide: function(e) {
                var foundInputPanelOpen = false;

                // Close any open input and panels
                t.controllers.find(this.$el, 'shop-product').forEach(function(product) {
                    if (product.isInputPanelOpen()) {
                        foundInputPanelOpen = true;
                        product.hideInputPanel();
                    }
                });

                // Cancel closing of details panel if the user was just trying to close the input panel
                if (foundInputPanelOpen) {
                    e.preventDefault();
                }
            },
            reload: function() {
                this.$el.addClass('loading');

                var mode = this.$el.attr('data-mode');
                var url = this.options.reloadUrl + "?_cb=" + Date.now() + "&mode=" + mode;

                $.getJSON(url).success(
                    t.util.bind(function(data) {
                        // Add new product HTML and initialise controllers
                        t.controllers.purge(this.$el);
                        this.$el.html(data.products_html);
                        t.controllers.init(this.$el);

                        this._updateDisplay();
                        this.$el.removeClass('loading');
                    }, this)
                );
            },
            _updateDisplay: function() {
                // Apply latest product filter
                var filter = this._filter || {traySizeChanged: false};
                const rangeFilterChanged = (
                    Object.entries(filter).length > 1 &&
                    (
                        filter.premium !== this.originalRangeFiltersState.premium
                        || filter.classic !== this.originalRangeFiltersState.classic
                    )
                );
                // wait for the display to be updated before sendin the event
                if (rangeFilterChanged) {
                    this.originalRangeFiltersState.premium = filter.premium;
                    this.originalRangeFiltersState.classic = filter.classic;
                }
                if (filter) {
                    var numVisibleProducts = 0;
                    var numExcludedProducts = 0;
                    let numExcludedFilteredProducts = 0;
                    let newAllExcludedProductsFilter = false;

                    t.controllers.find(this.$el, 'shop-product')
                        .forEach(function (product) {
                            if (product.isExcluded()) {
                                numExcludedProducts += 1;
                            }
                            if (product.matchesFilter(filter)) {
                                numVisibleProducts += 1;
                                product.show();
                            } else {
                                if(product.isExcluded()) {
                                    numExcludedFilteredProducts += 1;
                                }
                                product.hide();
                            }
                        });

                    newAllExcludedProductsFilter = numExcludedFilteredProducts === numExcludedProducts;
                    if (
                        this.allExcludedProductsFiltered !== newAllExcludedProductsFilter
                    ) {
                        this.allExcludedProductsFiltered = newAllExcludedProductsFilter
                        const $excludedRecipesComponent = this.$el.find('.excluded-recipes');
                        $excludedRecipesComponent.toggle();
                    }

                    // Display empty basket message if there are no products visible and we're in checkout mode
                    if (filter.zeroQuantity == false && numVisibleProducts == 0) {
                        this.$emptyBasketMessage.show();
                    } else {
                        this.$emptyBasketMessage.hide();
                    }

                    // Force show excluded recipes if we're in checkout mode, and hide the banner
                    if (numExcludedProducts === 0) {
                        this.$el.find('.excluded-recipes-banner').hide();
                    } else {
                        this.$el.find('.excluded-recipes-banner').show();
                    }

                    if (filter.zeroQuantity === false) {
                        this.$el.find('.excluded-recipes-banner').addClass('zero');
                        this.showExcludedRecipes();
                    } else {
                        this.$el.find('.excluded-recipes-banner').removeClass('zero');
                    }
                }

                // Update selection if necessary
                var selection = {
                    products: {},
                    totalQuantity: 0,
                    totalPrice: 0
                };
                t.controllers.find(this.$el, 'shop-product')
                    .forEach(function(listItem) {
                        selection.products[listItem.getProductId()] = listItem.getQuantity();
                        selection.totalQuantity += listItem.getQuantity();
                        selection.totalPrice += listItem.getTotalPrice();
                    });
                t.message.publish('shop', 'selection-change', selection);
                if (rangeFilterChanged || filter.traySizeChanged) {
                    if (filter.traySizeChanged) {
                        this.trayCountsByRanges = this.collectTraysCount();
                    }
                    let traysCount = {};
                    if (
                        this.originalRangeFiltersState.premium
                        && this.originalRangeFiltersState.classic
                    ) {
                        traysCount = this.trayCountsByRanges.bothRanges;
                    } else if (this.originalRangeFiltersState.premium) {
                        traysCount = this.trayCountsByRanges.premium;
                    } else {
                        traysCount = this.trayCountsByRanges.classic;
                    }
                    t.message.publish(
                        'filter-trays-count',
                        'change',
                        {
                            'traysCount': traysCount
                        }
                    )
                };
            },
            collectTraysCount: function() {
                let trayCountsByRanges = {
                    bothRanges: {},
                    premium: {},
                    classic:{},
                };
                t.controllers.find(this.$el, 'shop-product').forEach(function (product) {
                    for (const rangeType in trayCountsByRanges) {
                        let properties = ['flavour', 'texture'];
                        if (rangeType === 'bothRanges') {
                            properties.push('range');
                        }
                        for (const property of properties) {
                            if (rangeType === 'bothRanges' || rangeType === product.options.range) {
                                if (
                                    typeof trayCountsByRanges[rangeType][product.options[property]] === 'undefined'
                                ) {
                                    trayCountsByRanges[rangeType][product.options[property]] = 0;
                                }
                                trayCountsByRanges[rangeType][product.options[property]] += 1;
                            }
                        }
                    }
                });
                for (const [a, b] of [['premium', 'classic'], ['classic', 'premium']]) {
                    // trays count by range is only done for the bothRanges key.
                    // So to always get the overall trays count by range regardless.
                    trayCountsByRanges[a][a] = trayCountsByRanges['bothRanges'][a]
                    trayCountsByRanges[a][b] = trayCountsByRanges['bothRanges'][b]

                    for (const filter in trayCountsByRanges[a]) {
                        if (!Object.keys(trayCountsByRanges[b]).includes(filter)) {
                            trayCountsByRanges[b][filter] = 0
                        }
                    }
                }
                return trayCountsByRanges;
            }
        }
    );

    t.controllers.define(
        'shop-product',
        {
            'click .product': 'onRowClick',
            'click .product-details-link': 'toggleDetails',
            'click .details': 'toggleDetails',
            'click button.buy': 'onBuyButtonClick',
            'click button.plusminus': 'onPlusMinusButtonClick',
            'click button.setquantity': 'onSetQuantityClick',
            'click button.remove': 'onRemoveButtonClick',
            'change input': 'onQuantityInputChange',
            'keypress input': 'onQuantityInputKeypress',
            'click .input-panel': 'onInputPanelClick'
        },
        {
            'init:after': function() {
                this.$inputField = this.$el.find('input');
                this.$buyButton = this.$el.find('button.buy');
                this.$disabled_reason = undefined;
                this.$product_type = this.$el.data("product-type");
                this.$product_id = this.$el.data("product-id");
                t.message.subscribe('shop-product', 'clear', t.util.bind(this.zeroQuantity, this));
                t.message.subscribe('shop-product', 'disable', t.util.bind(this.disable, this));
                t.message.subscribe('shop-product', 'enable', t.util.bind(this.enable, this));
                t.message.subscribe('shop-product', 'setQuantity', t.util.bind(this.setQuantity, this));
                // t.message.subscribe('shop-selection-mode', 'change', t.util.bind(this.onSelectionModeChange, this));
            },
            disable: function (e) {
                this.$disabled_reason = e['data'];
            },
            enable: function (e) {
                this.$disabled_reason = undefined;
            },
            getProductId: function() {
                return this.options.productId;
            },
            isExcluded: function() {
                return this.$el.hasClass('excluded');
            },
            setRecommendedQuantity: function(newQuantity) {
                this._setQuantity(newQuantity);
            },
            setQuantity: function(newQuantity) {
                var that = this;
                this._setQuantity(newQuantity, function () {
                    that._changed();
                });
            },
            _setQuantity: function(amount, changeCallback) {
                var current = this.getQuantity();
                var excludedMessage = this.options.suitabilityMessage;

                var context = this;

                if(current === 0 && amount > 0 && this.isExcluded()) {
                    t.ui.alert.show(
                        '',
                        '',
                        excludedMessage,
                        [
                            t.ui.alert.BUTTON_NO,
                            t.ui.alert.BUTTON_YES
                        ],
                        function (button) {
                            if (button === t.ui.alert.BUTTON_NO) {
                                context.setQuantity(0);
                            } else {
                                window.dataLayer.push({
                                    event: 'ga',
                                    eventCategory: 'wet-food-shop',
                                    eventAction: 'add-excluded',
                                    eventLabel: button
                                });
                            }
                        }
                    );
                }
                if (amount !== current) {
                    this.$inputField.val(amount);
                    if (changeCallback) {
                        changeCallback();
                    }
                }
            },
            zeroQuantity: function() {
              this.setQuantity(0);
            },
            getQuantity: function() {
                return parseInt(this.$inputField.val(), 10);
            },
            getTotalPrice: function() {
                return this.options.price * this.getQuantity();
            },
            onRowClick: function(e) {
                e.preventDefault();
                e.stopPropagation();

                // Hide input panel if it's open, otherwise toggle details unless the click came from within the details
                // panel.
                if (this.isInputPanelOpen()) {
                    this.hideInputPanel();
                }
            },
            onBuyButtonClick: function(e) {
                e.preventDefault();
                e.stopPropagation();

                if (this.getQuantity() === 0) {
                    var success = this.setQuantity(1);
                    if(success) {
                        this.showInputPanel();
                    }
                }
                else {
                    this.showInputPanel();
                }
            },
            showInputPanel: function() {
                if (this.isInputPanelOpen() === false) {
                    var e = $.Event('shop-product:input-panel:show');
                    this.$el.trigger(e);
                    if (e.isDefaultPrevented() !== true) {
                        this.$el.addClass('input');
                    }
                }
            },
            hideInputPanel: function() {
                if (this.isInputPanelOpen()) {
                    var e = $.Event('shop-product:input-panel:hide');
                    this.$el.trigger(e);
                    if (e.isDefaultPrevented() !== true) {
                        this.$el.removeClass('input');
                    }
                }
            },
            isInputPanelOpen: function() {
                return this.$el.hasClass('input');
            },
            toggleDetails: function() {
                this.$el.find('.icon-chevron-down').toggleClass('toggled-details')
                this.$el.find('.icon-chevron-up').toggleClass('toggled-details')
                if (this.isDetailsOpen()) {
                    this.hideDetails();
                } else {
                    this.showDetails();
                }
            },
            showDetails: function() {
                if (this.isDetailsOpen() === false) {
                    var e = $.Event('shop-product:details:show');
                    this.$el.trigger(e);
                    if (e.isDefaultPrevented() !== true) {
                        window.dataLayer.push({
                            event: 'ga',
                            eventCategory: 'wet-food-shop',
                            eventAction: 'product-details',
                            eventLabel: 'show'
                        });

                        this.$el.addClass('details');
                    }
                }
            },
            hideDetails: function() {
                if (this.isDetailsOpen()) {
                    var e = $.Event('shop-product:details:hide');
                    this.$el.trigger(e);
                    if (e.isDefaultPrevented() !== true) {
                        window.dataLayer.push({
                            event: 'ga',
                            eventCategory: 'wet-food-shop',
                            eventAction: 'product-details',
                            eventLabel: 'hide'
                        });
                        this.$el.removeClass('details');
                    }
                }
            },
            isDetailsOpen: function() {
                return this.$el.hasClass('details');
            },
            onInputPanelClick: function(e) {
                // Catch all other click events for input panel and descendants and suppress them
                e.stopPropagation();
            },
            onSetQuantityClick: function(e){
                var quantity = parseInt($(e.currentTarget).attr("data-quantity"));
                this.setQuantity(quantity);
            },
            onPlusMinusButtonClick: function(e) {
                e.preventDefault();
                e.stopPropagation();

                if($(e.currentTarget).data("event")) {
                    t.message.publish('tracking', 'event', $(e.currentTarget).data("event"));
                }

                var isPlusButton = $(e.currentTarget).hasClass('plus');
                var quantity = parseInt($(e.currentTarget).attr("data-quantity") || 1);
                var currentValue = parseInt(this.$inputField.val(), 10);

                if (isPlusButton) {
                    currentValue = currentValue + quantity;
                }
                else {
                    currentValue = Math.max(currentValue - quantity, 0);
                }

                var label = currentValue > 0 ? "plus" : "minus";
                window.dataLayer.push({
                    event: 'ga',
                    eventCategory: 'wet-food-shop',
                    eventAction: this.$product_type,
                    eventLabel: label
                });

                this.setQuantity(currentValue);

            },
            onRemoveButtonClick: function(e) {
                this.$inputField.val(0);
                this._changed();
                this.hideInputPanel();
            },
            onQuantityInputChange: function(e) {
                var val = parseInt(this.$inputField.val(), 10);

                // Restore the old value for non-numeric input
                if (isNaN(val)) {
                    val = (typeof this._oldValue === 'undefined') ? this.$inputField.attr('value') : this._oldValue;
                }

                // Reapply value, just in case parsing changed the meaning
                this.$inputField.val(val);

                this._changed();
            },
            onQuantityInputKeypress: function(e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    this._changed();
                    this.hideInputPanel();
                }
            },
            matchesFilter: function(filter) {
                if(filter === undefined) {
                    return true;
                }
                const matchTexture = filter[this.options.texture] !== false;
                const matchRange = filter[this.options.range] !== false;
                const matchFlavour = filter[this.options.flavour] !== false;

                let match = matchTexture && matchRange && matchFlavour;
                if (filter.zeroQuantity === false && this.getQuantity() === 0) {
                    match = false;
                }

                return match;
            },
            show: function() {
                this.$el.removeClass('filtered');
            },
            hide: function() {
                this.$el.addClass('filtered');
            },
            _changed: function() {
                var that = this;
                var currentValue = parseInt(this.$inputField.val(), 10);

                if (currentValue > this._oldValue && this.$disabled_reason) {
                    t.ui.alert.show(
                        '',
                        '',
                        this.$disabled_reason,
                        [
                            t.ui.alert.BUTTON_OK
                        ],
                        function() {
                            that.$inputField.val(that._oldValue);
                        }
                    );
                    return;
                }

                if (currentValue === 0) {
                    this.$buyButton.removeClass('buy-number');
                    this.$buyButton.html('<span class="icon icon-plus"></span>');
                } else {
                    this.$buyButton.text(currentValue);
                    this.$buyButton.addClass('buy-number');
                }

                t.message.publish('shop-product', 'change', {
                    oldValue: !isNaN(this._oldValue) ? this._oldValue : parseInt(this.$inputField.attr('value')) || 0,
                    newValue: currentValue,
                    sender: this
                });

                // Store for future reference
                this._oldValue = currentValue;
            }
        }
    );

    // Map for 1/3 or 1/4 decimal fractions to HTML fraction entity. DTSTTCPW
    var FRACTION_ENTITY_MAP = {
        '0.00': '',
        '0.25': '&frac14;',
        '0.33': '&frac13;',
        '0.50': '&frac12;',
        '0.67': '&frac23;',
        '0.75': '&frac34;'
    };

    t.controllers.define(
        'wet-other-food-updater',
        {
            'click a.wet-food-not-sure': 'onFoodNotSureClick',
            'click a.other-food-not-sure': 'onFoodNotSureClick',
            'click .close': 'onCloseClick',
            'click div.food-type-wrapper': 'onCheckboxClick',
            'keypress input[type=text]': 'onInputKeyPress',
            'input input': 'onInputChange',
        },
        {
            'init:after': function() {
                this.$wetKcalWarning = $('.wet-kcal-warning').hide();
                this.$wetKcalError = $('.wet-kcal-error').hide();
                this.$totalKcalWarning = $('.total-kcal-warning').hide();
                this.$totalKcalError = $('.total-kcal-error').hide();

                this.$wetFoodInput = this.$el.find('input#wet-grams-per-day');
                this.$otherFoodInput = this.$el.find('input#other-kcal-percent');
                this.$wetEquivalents = this.$el.find('.wet-equivalents');

                this.$originalWetFoodValue = this.$wetFoodInput.val();
                this.$originalOtherFoodValue = this.$otherFoodInput.val();

                this.$el.find('.wet-recommendation').removeClass('hide').hide();
                this.$el.find('.other-recommendation').removeClass('hide').hide();

                this.$wetFoodCheckbox = this.$el.find('input#wet_food');
                this.$otherFoodCheckbox = this.$el.find('input#other_food');

                this.$el.find('button').prop('disabled', true);
            },
            onCheckboxClick() {
                this.update();
            },
            onFoodNotSureClick(e) {
                e.preventDefault();
                $(e.target).next().slideToggle('fast');
            },
            onCloseClick(e) {
                e.preventDefault();
                $(e.currentTarget).slideUp('fast');
            },
            onInputKeyPress(e) {
                // e.keyCode is not supported in various modern browsers, which
                // means a customer CANNOT add the amount, so try the jQuery
                // specific version as well. Ideally, we'd not need this as
                // using number types in form inputs may be a better idea in
                // general.
                const keyCode = e.which || e.keyCode;

                // 0-9 only
                if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 46) {
                    e.preventDefault();
                }
            },
            update() {
                const useGrams = this.$wetFoodCheckbox.is(':checked');
                const useOtherCal = this.$otherFoodCheckbox.is(':checked');

                const wetGrams = useGrams ? parseInt(this.$wetFoodInput.val(), 10) : 0;

                // check if the value has changed
                if (this.$wetFoodInput.val() !== this.$originalWetFoodValue ||
                    this.$otherFoodInput.val() !== this.$originalOtherFoodValue) {
                    this.$el.find('button').prop('disabled', false);
                } else {
                    this.$el.find('button').prop('disabled', true);
                }

                if (wetGrams) {
                    let wetEquivalentVisibleCount = 0;
                    this.$wetEquivalents.find('li').each((_index, el) => {
                        const $el = $(el);

                        // Calculate amount and round to nearest quarter / third
                        let amount = wetGrams / parseInt($el.data('weight'), 10);
                        const amountQuarters = Math.round(amount * 4) / 4;
                        const amountThirds = Math.round(amount * 3) / 3;
                        amount = Math.abs(amount - amountQuarters) < Math.abs(amount - amountThirds) ? amountQuarters : amountThirds;

                        // Format as HTML
                        const amountInt = Math.floor(amount);
                        const amountFrac = amount - amountInt;
                        let value = '';
                        if (amountInt) {
                            value += amountInt;
                        }
                        value += FRACTION_ENTITY_MAP[amountFrac.toFixed(2)];

                        if (value) {
                            $el.removeClass('hide');
                            $el.find('.amount').html(value);
                            wetEquivalentVisibleCount += 1;
                        } else {
                            $el.addClass('hide');
                        }
                    });

                    if (wetEquivalentVisibleCount) {
                        this.$wetEquivalents.removeClass('hide').slideDown('fast');
                    } else {
                        this.$wetEquivalents.slideUp('fast');
                    }
                } else {
                    this.$wetEquivalents.slideUp('fast');
                }

                const petKcalTarget = parseFloat(this.options.petKcalTarget, 10);
                const wetKcals = wetGrams * this.options.wetKcalPerGram;
                const wetKcalPercent = ((wetKcals / petKcalTarget) * 100) || 0;
                const otherKcalPercent = useOtherCal ? parseInt(this.$otherFoodInput.val(), 10) : 0;

                const totalKcalPercent = wetKcalPercent + otherKcalPercent;

                if (wetKcalPercent > 100) {
                    this.$wetKcalError.find('.pet-name').text(this.options.petName);
                    this.$wetKcalError.find('.pet-object').text(this.options.petObject);
                    this.$wetKcalError.find('.pet-possessive').text(this.options.petPossessive);
                    this.$wetKcalError.find('.pet-pronoun').text(this.options.petPronoun);
                    this.$wetKcalError.find('.wet-weight').text(this.options.wetKcalGramsWarningThreshold);

                    this.$wetKcalError.appendTo(this.$el.find('.wet-food-error')).slideDown('fast');
                } else {
                    this.$wetKcalError.slideUp('fast');
                    this.$wetKcalError.removeClass('hidden');
                }

                if (totalKcalPercent > this.options.totalKcalPercentErrorThreshold) {
                    this.$totalKcalError.find('.percent').text(totalKcalPercent.toFixed(0));
                    this.$totalKcalError.find('.threshold-percent').text(this.options.totalKcalPercentErrorThreshold);
                    this.$totalKcalError.find('.pet-name').text(this.options.petName);
                    this.$totalKcalError.appendTo(this.$el.find('.other')).slideDown('fast');

                    this.$totalKcalWarning.slideUp('fast');
                    this.$totalKcalWarning.removeClass('hidden');

                    this.$wetFoodInput.addClass('with-error');
                    this.$otherFoodInput.addClass('with-error');

                    this.$el.find('button').prop('disabled', true);
                } else if (totalKcalPercent > this.options.totalKcalPercentWarningThreshold) {
                    this.$totalKcalWarning.find('.percent').text(totalKcalPercent.toFixed(0));
                    this.$totalKcalWarning.find('.threshold-percent').text(this.options.totalKcalPercentWarningThreshold);
                    this.$totalKcalWarning.find('.pet-name').text(this.options.petName);
                    this.$totalKcalWarning.appendTo(this.$el.find('.other')).slideDown('fast');

                    this.$totalKcalError.slideUp('fast');
                    this.$totalKcalError.removeClass('hidden');

                    this.$wetFoodInput.addClass('with-warning');
                    this.$otherFoodInput.addClass('with-warning');

                    this.$el.find('button').prop('disabled', false);
                } else {
                    this.$wetFoodInput.removeClass('with-error').removeClass('with-warning');
                    this.$otherFoodInput.removeClass('with-error').removeClass('with-warning');

                    this.$totalKcalWarning.slideUp('fast');
                    this.$totalKcalError.slideUp('fast');
                    this.$totalKcalWarning.removeClass('hidden');
                    this.$totalKcalError.removeClass('hidden');

                    this.$el.find('button').prop('disabled', false);
                }

                if (wetKcalPercent > this.options.wetKcalPercentWarningThreshold) {
                    this.$wetKcalWarning.find('.wet-grams').text(wetGrams);
                    this.$wetKcalWarning.find('.percent').text(wetKcalPercent.toFixed(1));
                    this.$wetKcalWarning.find('.threshold-percent').text(this.options.wetKcalPercentWarningThreshold);
                    this.$wetKcalWarning.find('.threshold-grams').text(this.options.wetKcalGramsWarningThreshold);
                    this.$wetKcalWarning.find('.pet-name').text(this.options.petName);
                    this.$wetKcalWarning.appendTo(this.$el.find('.wet')).slideDown('fast');
                    this.$wetFoodInput.addClass('with-warning');
                } else {
                    this.$wetFoodInput.removeClass('with-warning');
                    this.$wetKcalWarning.slideUp('fast');
                    this.$wetKcalWarning.removeClass('hidden');
                }
            },
            onInputChange(e) {
                if (this._updateTimeout) {
                    clearTimeout(this._updateTimeout);
                }
                this._updateTimeout = setTimeout(t.util.bind(this.update, this), 300);
            }
        }
    );

    t.controllers.define(
        'photo-upload',
        {
            'click .save': 'save'
        },
        {
            'init:after': function() {
                const that = this;

                this.form = this.$el.find('.form');
                this.file_input = this.$el.find('input[name=photo]');
                this.image = this.$el.find('.form .image');
                this.message = this.$el.find('.form .message');
                this.thumbnail_canvas = this.$el.find('.form .thumbnail').get(0);
                this.result = this.$el.find('.form .result img');
                this.error = this.$el.find('.form .error');
                this.save = this.$el.find('.save');
                this.upload_message = this.$el.find('.upload-message');
                this.success_message = this.$el.find('.success-message');
                this.canvas = this.$el.find('.canvas');

                this.form.find('.result').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    that.file_input.click();
                });

                this.file_input.on('change', function(e){
                    that.photo = e.target.files[0];
                    that.render_image(that.photo);
                });

                this.form.on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                })
                .on('dragover dragenter', function() {
                    that.form.addClass('dragover');
                })
                .on('dragleave dragend drop', function() {
                    that.form.removeClass('dragover');
                })
                .on('drop', function(e) {
                    that.photo = e.originalEvent.dataTransfer.files[0];
                    that.render_image(that.photo);
                });
            },

            render_image: function(file) {
                const that = this;
                const reader = new FileReader();
                that.error.text('').removeAttr('data-type');
                reader.onload = function (e) {
                    that.form.attr('data-status', 'edit');
                    that.canvas.cropper({
                        aspectRatio: 1,
                        responsive: true,
                        viewMode: 1,
                        preview: this.image,
                        dragMode: 'move'
                    });
                    that.canvas.cropper('replace', e.target.result);
                    that.save.addClass('show');
                };
                reader.readAsDataURL(file);
            },

            save: function(e) {
                const that = this;
                e.preventDefault();
                e.stopPropagation();

                const cropped_canvas = this.canvas.cropper('getCroppedCanvas');
                const thumbnail = this.resize(cropped_canvas, 300, 300);

                that.form.attr('data-status', 'loading');
                that.save.removeClass('show');

                thumbnail.toBlob(function (blob) {
                    const data = new FormData();
                    data.append('photo', blob);
                    data.append('csrf_token', that.form.find('#csrf_token').val());
                    $.ajax({
                        type: 'POST',
                        url: that.form.attr('action'),
                        data: data,
                        dataType: 'json',
                        cache: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            setTimeout(function() {

                                if(data['success']) {
                                    that.canvas.cropper('destroy');
                                    that.form.attr('data-status', 'success');
                                    const now = new Date();
                                    that.result.attr('src', data['url'] + '?' + now.getTime());
                                    that.upload_message.addClass('hide');
                                    that.success_message.removeClass('hide');

                                }
                                else {
                                    that.form.attr('data-status', 'edit');
                                    that.error.text(data['message']);
                                    that.save.addClass('show');
                                }
                            }, 3000);
                        },
                        error: function (e) {
                            that.error.text(e['responseText']);
                            that.form.attr('data-status', 'edit');
                            that.form.find('.actions .save').prop('disabled', false);
                        }
                    });
                }, 'image/jpeg');
            },

            resize: function(canvas, height, width) {
                const ctx = this.thumbnail_canvas.getContext('2d');
                this.thumbnail_canvas.width = width;
                this.thumbnail_canvas.height = height;
                ctx.drawImage(canvas, 0, 0, width, height);
                return this.thumbnail_canvas
            }
        }
    );

    t.controllers.define(
        'postcard-form',
        {
            'keyup input': 'onTextInputChange'
        },
        {
            'init:after': function () {
                var that = this;
                this.recipient_placeholder = this.$el.find(".placeholder.recipients-name");
                this.pets_name_placeholder = this.$el.find(".placeholder.pets-name");

                this.$el.find("input[type=text]").each(function(i, input) {
                    that.updatePlaceholders(input);
                });
            },
            'onTextInputChange': function (e) {
                this.updatePlaceholders(e.target);
            },
            'updatePlaceholders': function (input) {
                input = $(input);
                var target_name = input.attr("name");
                if(target_name == "first_name") {
                    this.recipient_placeholder.text(input.val());
                }
                else if(target_name == "dogs_name") {
                    this.pets_name_placeholder.text(input.val());
                }
            }
        }
    );

    t.controllers.define(
        'auto-wet-food',
        {
            'change .filters input': 'onInputChange',
            'click .range-input': 'onInputChange',
            'click .range-select': 'onRangeSelect',
            'click .accordion-title-included': 'onAccordionInc',
            'click .accordion-title-excluded': 'onAccordionEx',
            'click .accordion-title-flavours': 'onAccordionFlav',
            'click .accordion-title-textures': 'onAccordionText',
            'click .accordion-title-ranges': 'onAccordionRang',
            'click .openbtn': 'openNav',
            'click .closebtn': 'closeNav',
            'click #sideNav': 'closeNavOuter',
        },
        {
            'init:after': function () {
                this.url = this.$el.attr('data-target');
                this.to = null;
                this.hideExcludedIfEmpty();
            },
            'onInputChange': function(e) {
                clearTimeout(this.to);
                this.to = setTimeout(t.util.bind(this.update, this), 600);
            },
            'onRangeSelect': function(e) {
                //Deprecated on the new automatic shop
                const range = $(e.currentTarget).attr("data-range")
                const modal = document.getElementsByClassName("modal")[0]
                const modalCover = document.getElementsByClassName("modal-cover")[0]

                if(modal && modalCover) {
                    modal.style.display = 'none'
                    modalCover.style.display = 'none'
                }

                if(range === 'premium') {
                    $(".classic-js").removeClass('selected');
                    $(".premium-js").addClass('selected');
                }

                if(range === 'classic') {
                    $(".classic-js").addClass('selected');
                    $(".premium-js").removeClass('selected');
                }
            },
            'update': function() {
                $.post(
                    this.url,
                    this.$el.serialize()
                ).success(
                    t.util.bind(function(data) {
                        this.$el.find('.products .product').each(function(i, elem) {
                            elem = $(elem);
                            let product_id = elem.attr('data-product-id');
                            let quantity = data[product_id] || 0;
                            elem.attr('data-quantity', quantity);
                            elem.find('.quantity .value').text(quantity);
                        });
                    }, this)
                )
                this.to = setTimeout(t.util.bind(this.hideExcludedIfEmpty, this), 600);
            },
            'onAccordionInc': function(e) {
                this.$el.find('.accordion-content-included').toggle(); // hide, show
                this.$el.find('.icon-included-open').toggle();
                this.$el.find('.icon-included-close').toggle();
            },
            'onAccordionEx': function(e) {
                this.$el.find('.accordion-content-excluded').toggle(); // hide, show
                this.$el.find('.icon-excluded-open').toggle();
                this.$el.find('.icon-excluded-close').toggle();
            },
            'onAccordionFlav': function(e) {
                this.$el.find('.accordion-content-flavours').toggle(); // hide, show
                this.$el.find('.icon-flavours-open').toggle();
                this.$el.find('.icon-flavours-close').toggle();
            },
            'onAccordionText': function(e) {
                this.$el.find('.accordion-content-textures').toggle(); // hide, show
                this.$el.find('.icon-textures-open').toggle();
                this.$el.find('.icon-textures-close').toggle();
            },
            'onAccordionRang': function(e) {
                this.$el.find('.accordion-content-ranges').toggle(); // hide, show
                this.$el.find('.icon-ranges-open').toggle();
                this.$el.find('.icon-ranges-close').toggle();
            },
            'openNav': function (e) {
                var sideNav = document.getElementById("sideNav");
                sideNav.style.width = "100%";
                document.body.style.overflow = "hidden";
            },
            'closeNav': function (e) {
                document.getElementById("sideNav").style.width = "0";
                document.body.style.overflow = "visible";
                document.body.style.position = '';
                document.body.style.top = '';
            },
            'closeNavOuter': function (e) {
                var inner = document.getElementById("innerSideNav");
                if(!inner.contains(e.target)) {
                    this.closeNav();
                };
            },
            'hideExcludedIfEmpty': function(e) {
                const excludedTab = this.$el.find('.excluded');
                excludedTab.find('[data-quantity]');
                let shouldHide = true
                this.$el.find('.excluded').find('.selected').find('[data-quantity]').each(function (i, elem) {
                    if (elem.dataset.quantity === '0') {
                        shouldHide = false
                    }
                })

                if (shouldHide === true) {
                    excludedTab.hide()
                } else {
                    excludedTab.show()
                }
            },
        }
    );

    t.controllers.define(
        'auto-wet-food-mixed',
        {
            'change .filters input': 'onInputChange',
            'click .range-input': 'onInputChange',
            'click .range-select': 'onRangeSelect',
            'click .accordion-title-included': 'onAccordionInc',
            'click .accordion-title-excluded': 'onAccordionEx',
            'click .accordion-title-flavours': 'onAccordionFlav',
            'click .accordion-title-textures': 'onAccordionText',
            'click .accordion-title-ranges': 'onAccordionRang',
            'click .openbtn': 'openNav',
            'click .closebtn': 'closeNav',
            'click #sideNav': 'closeNavOuter',
            'click .save-selection': 'doNotAskBeforeUnload',
            'click .wet-food-selector-link': 'doNotAskBeforeUnload',
            'click .pause-wet-food-link': 'doNotAskBeforeUnload',
            'click .recovery': 'doNotAskBeforeUnload',
        },
        {
            'init:after': function () {
                this.url = this.$el.attr('data-target');
                this.onRangeSelect();
                this.update();
                this.disableZeroCountButtons();
                this.filtersOgState = this.getFiltersState();
                this.filtersNewState = [...this.filtersOgState];
                window.onbeforeunload = (e) => {
                        if(
                           JSON.stringify(this.filtersOgState) !== JSON.stringify(this.filtersNewState)
                        ){
                            e.preventDefault()
                            return e.returnValue = "";
                        }
                    }
            },
            'onInputChange': function () {
                setTimeout(t.util.bind(this.update, this), 600);
            },
            'onRangeSelect': function (e) {
                let ranges = [];
                // upsell code
                let data_range = null;
                if (e) {
                    data_range = $(e.currentTarget).attr("data-range");
                }
                if (data_range) {
                    ranges = [data_range]
                }
                document.querySelectorAll('.ranges-input-elem').forEach(function (elem) {
                    if (data_range) {
                        // upsell code
                        if (data_range === "mixing") {
                            elem.checked = true;
                        }
                        else if (elem.value === data_range) {
                            elem.checked = true;
                        }
                        else {
                            elem.checked = false;
                        }
                    } else {
                         if (elem.checked) {
                            ranges.push(elem.value);
                        }
                    }
                });

                // Don't allow both ranges to be unchecked
                if (ranges.length === 0) {
                    e.preventDefault();
                    return
                }
                if (ranges.includes('classic') && ranges.includes('premium') || ranges.includes('mixing')) {
                    $(".mixing-js").addClass('selected');
                    $(".premium-js").removeClass('selected');
                    $(".classic-js").removeClass('selected');
                    $(".mixed-upsell").removeClass('selected');
                    // compensate window "scrolling" after hiding
                    // premium upsell banner. Only when from tablet upwards.
                    if (window.innerWidth >= 800 && typeof e !== 'undefined' && e.currentTarget.id === "ranges-premium") {
                        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
                        window.scrollTo(scrollLeft, scrollTop - 380);
                    }
                }
                else if (!ranges.includes('classic')) {
                    $(".classic-js").removeClass('selected');
                    $(".mixing-js").removeClass('selected');
                    $(".premium-js").addClass('selected');
                }

                else if (!ranges.includes('premium')) {
                    $(".classic-js").addClass('selected');
                    $(".mixing-js").removeClass('selected');
                    $(".premium-js").removeClass('selected');
                }
                this.disableZeroCountButtons();
            },
            'update': function () {
                $.post(
                    this.url,
                    this.$el.serialize()
                ).success(
                    t.util.bind(function (data) {
                        const that = this;
                        this.$el.find('.products .product').each(function (i, elem) {
                            elem = $(elem);
                            let product_id = elem.attr('data-product-id');
                            let quantity = data[product_id] || 0;
                            elem.attr('data-quantity', quantity);
                            elem.find('.quantity .value').text(quantity);
                            that.hideExcludedIfEmpty()
                            that.filtersNewState = that.getFiltersState()
                            // checking for "forced" ranges params so they can save the offered selection
                            const urlSearchParams = new URLSearchParams(window.location.search);
                            const params = Object.fromEntries(urlSearchParams);

                            if (params.ranges !== undefined ||
                                JSON.stringify(that.filtersOgState) !== JSON.stringify(that.filtersNewState)) {
                                that.toggleEditMode(true);
                            } else {
                                that.toggleEditMode(false);
                            }
                        });
                    }, this)
                )
            },
            'onAccordionInc': function (e) {
                this.$el.find('.accordion-content-included').toggle(); // hide, show
                this.$el.find('.icon-included-open').toggle();
                this.$el.find('.icon-included-close').toggle();
            },
            'onAccordionEx': function (e) {
                this.$el.find('.accordion-content-excluded').toggleClass('accordion-content-if-desktop-grid'); // hide, show
                this.$el.find('.icon-excluded-open').toggle();
                this.$el.find('.icon-excluded-close').toggle();
            },
            'onAccordionFlav': function (e) {
                this.$el.find('.accordion-content-flavours').toggle(); // hide, show
                this.$el.find('.icon-flavours-open').toggle();
                this.$el.find('.icon-flavours-close').toggle();
            },
            'onAccordionText': function (e) {
                this.$el.find('.accordion-content-textures').toggle(); // hide, show
                this.$el.find('.icon-textures-open').toggle();
                this.$el.find('.icon-textures-close').toggle();
            },
            'onAccordionRang': function (e) {
                this.$el.find('.accordion-content-ranges').toggle(); // hide, show
                this.$el.find('.icon-ranges-open').toggle();
                this.$el.find('.icon-ranges-close').toggle();
            },
            'openNav': function (e) {
                var sideNav = document.getElementById("sideNav");
                sideNav.style.width = "100%";
                document.body.style.overflow = "hidden";
            },
            'closeNav': function (e) {
                document.getElementById("sideNav").style.width = "0";
                document.body.style.overflow = "visible";
                document.body.style.position = '';
                document.body.style.top = '';
            },
            'closeNavOuter': function (e) {
                var inner = document.getElementById("innerSideNav");
                if(!inner.contains(e.target)) {
                    this.closeNav();
                };
            },
            'hideExcludedIfEmpty': function () {
                const excludedTab = this.$el.find('.excluded');
                let shouldHide = true
                excludedTab.find('[data-quantity]').each(function (_, elem) {
                    if (elem.dataset.quantity === '0') {
                        shouldHide = false
                    }
                })
                if (shouldHide === true) {
                    excludedTab.hide()
                } else {
                    excludedTab.show()
                }
            },
            'disableZeroCountButtons': function (e) {
                // Hide options when no products exist with that filter
                document.querySelectorAll('.filter-item').forEach(function (elem) {
                    let tray = elem.closest(".tray_counts")
                    if (tray.classList.contains('selected')) {
                        elem.closest('li').querySelector('input').disabled = elem.dataset.count === '0'
                    }
                })
            },
            'getFiltersState': function() {
                let filtersState = [];
                this.$el.find('.checkbox-wrapper-alt').each(function(_, elem) {
                    if (elem.querySelector(".filter-input").checked) {
                        filtersState.push(elem.querySelector(".filter-input").id);
                    }
                });
                return filtersState;
            },
            'doNotAskBeforeUnload': function() {
                window.onbeforeunload = () => {};
            },
            'toggleEditBtns': function (notEqualFilters) {
                let editModeBtns = this.$el.find('.edit-mode-btns');
                let updateBtn = this.$el.find('.update');

                editModeBtns.each((_, elem) => {
                    elem.classList.toggle('display', notEqualFilters);
                });

                if (editModeBtns.hasClass('display')){
                    updateBtn.removeClass('btn-primary saved-selection');
                    updateBtn.addClass('btn-secondary preview-selection');
                } else {
                    updateBtn.addClass('btn-primary saved-selection');
                    updateBtn.removeClass('btn-secondary preview-selection');
                }
            },
            'toggleEditMode': function (bool) {
                if (this.$el.find('.accordion-content .no-wet-food-available').length === 0) {
                    this.toggleEditBtns(bool);
                    const shownClasses = '.preview-selection';
                    const hiddenClasses = '.saved-selection';
                    let shown = bool ? this.$el.find(shownClasses) : this.$el.find('.saved-selection');
                    let hidden = bool ? this.$el.find(hiddenClasses) : this.$el.find('.preview-selection');
                    let incAccordionTitle = this.$el.find('.accordion-title-included');
                    let incAccordionContent = this.$el.find('.accordion-content.accordion-content-included');

                    this.$el.find('.accordion-content-included').show()
                    shown.each((_, elem) => {
                        if (elem.classList.contains('range-wrapper')) {
                            elem.style.display = "block";
                        } else {
                            elem.style.display = "inline-block";
                        }
                    });

                    hidden.each((_, elem) => {
                        elem.style.display = "none";
                    });

                    incAccordionTitle.each((_, elem) => {
                        elem.style.display = bool ? "none" : "flex";
                    });
                    incAccordionContent.each((_, elem) => {
                        $(elem).toggleClass('title-hidden-pad', bool);
                    });
                }
            },
        }
    );

    t.controllers.define(
        'cancellation',
        {
            'click a.restart': 'onButtonClick'
        },
        {
            'onButtonClick': function () {
                window.dataLayer.push({
                    event: 'ga',
                    eventCategory: 'cancellation',
                    eventAction: 'restart',
                    eventLabel: this.options.identifier
                });
            }
        }
    )

    t.controllers.define(
        'portion-wet',
        {
            'click #minus': 'onMinus',
            'click #plus': 'onPlus',
            'click #bar': 'onHide',
            'click #input-grams-link': 'onShow',

        },
        {
            'init:after': function () {
                this.selector = this.$el.find('#amount');
                this.minus = this.$el.find('#minus');
                this.plus = this.$el.find('#plus');
                this.values = Array.from(this.selector.find('option')).map(el => el.value);
                const options = this.selector.find('option').toArray();
                for (let i = 0; i < options.length; i++) {
                    if (options[i].value === this.selector.val()) {
                        this.index = i;
                        break
                    }
                }
                this.adjust(0);
                this.form = this.$el.find('#input-grams-form');
                this.link = this.$el.find('#input-grams-link');
                this.bar = this.$el.find('#bar');
            },
            // Accepts `1` or `-1` to travel through tray selection, `0` sets up classes
            adjust: function (direction) {
                this.index = Math.min(Math.max(this.index + direction, 0), this.values.length - 1);
                if (this.index > 0) {
                    this.minus.addClass('clickable');
                }
                if (this.index < this.values.length - 1) {
                    this.plus.addClass('clickable');
                }
                if (this.index === 0) {
                    this.minus.removeClass('clickable');
                }
                if (this.index === this.values.length - 1) {
                    this.plus.removeClass('clickable');
                }
                this.selector.val(this.values[this.index]);
            },
            onMinus: function () {
                this.adjust(-1);
            },
            onPlus: function () {
                this.adjust(1);
            },
            onShow: function () {
                this.form.addClass('show');
                this.link.attr("style", "margin-bottom: 0");
            },
            onHide: function () {
                this.form.removeClass('show');
            }
        }
    )

    t.controllers.define(
        'portion-other',
        {
            'click #radio-only': 'onHide',
            'click #input-link': 'onShow',
        },
        {
            'init:after': function () {
                this.form = this.$el.find('#input-form');
                this.other = this.$el.find('#input-link');
                this.radio = this.$el.find('#radio-only');
                this.radios = this.$el.find('#radio-form');
                if (document.getElementById("other-portion--1") && document.getElementById("other-portion--1").hasAttribute("checked")){
                    this.onShow()
                }
            },
            onShow: function () {
                this.form.addClass('show');
                this.radios.attr("style", "margin-bottom: 0");
            },
            onHide: function () {
                this.form.removeClass('show');
            }

        }
    );

    t.controllers.define(
        'tutorial-space',
        {},
        {
            'init:after': function () {
                this.load();
            },
            load: function () {
                Vue.use(Croppa);
                const MTI_SEEN_GETTING_STARTED = 'mti-seen-getting-started-2';
                const MTI_SEEN_ADD_PHOTO = 'mti-seen-add-photo-2';
                const MTI_SEEN_MAKE_CHANGES = 'mti-seen-make-changes-2';
                const MTI_SEEN_LEARN_HOW = 'mti-seen-learn-how-2';
                const MTI_SEEN_PROMPT = 'mti-seen-prompt-2';

                // Experiments
                const MTI_SEEN_DIGESTION = 'mti-seen-digestion';
                const MTI_SEEN_SKIN_COAT = 'mti-seen-skin-coat';
                const MTI_SEEN_JOINTS = 'mti-seen-joints';


                const UPLOAD_PHOTO_ICON = '/static/images/camera.svg';
                const PET_UPLOAD = '/gb/api/dashboard-photo-upload';

                function getCurrentPet() {
                    // find the current slickdot slide, get the pet public id from inside, return that ID
                    // so the caller can use that to grab petty infoses
                    const currentlySelected = document.querySelector('.slick-current');
                    if (currentlySelected) {
                        return currentlySelected.dataset.pet_id;
                    }
                }

                function getCurrentPetName() {
                    // e.g. Fido
                    const currentlySelected = document.querySelector('.slick-current');
                    if (currentlySelected) {
                        const petIdString = String(currentlySelected.dataset.pet_id)
                        const petData = getPetData()[petIdString]
                        return petData.name;
                    }
                }

                function getCurrentPetPossessive() {
                    // e.g. "Fido's"
                    const currentlySelected = document.querySelector('.slick-current');
                    if (currentlySelected) {
                        const petIdString = String(currentlySelected.dataset.pet_id)
                        const petData = getPetData()[petIdString]
                        return petData.petPossessive;
                    }
                }

                function getCurrentPetPossessivePronoun(caps = false) {
                    // e.g. His Her
                    const currentlySelected = document.querySelector('.slick-current');
                    if (currentlySelected) {
                        const petIdString = String(currentlySelected.dataset.pet_id)
                        const petData = getPetData()[petIdString]
                        if (petData.gender === 'male') {
                            return (caps) ? "His" : "his"
                        } else {
                            return (caps) ? "Her" : "her"
                        }
                    }
                }

                function getCurrentPetSubjectiveCase(caps = false) {
                    // e.g. He She
                    const currentlySelected = document.querySelector('.slick-current');
                    if (currentlySelected) {
                        const petIdString = String(currentlySelected.dataset.pet_id)
                        const petData = getPetData()[petIdString]
                        if (petData.gender === 'male') {
                            return (caps) ? "He" : "he"
                        } else {
                            return (caps) ? "She" : "she"
                        }
                    }
                }

                function currentPetPossessives() {
                    return {
                        name: getCurrentPetName, // Fido
                        possessive: getCurrentPetPossessive, // Fido's
                        possessivePronoun: getCurrentPetPossessivePronoun, // His Her
                        subjective: getCurrentPetSubjectiveCase // He She
                    }
                }

                function getPetData() {
                    let petData = {};
                    const pets = document.querySelectorAll('#tutorial-space-pet-data .pet-data');
                    pets.forEach((pet, i) => {
                        const id = String(pet.dataset.petId);
                        petData[id] = {
                            pet_id: id,
                            name: pet.dataset.name,
                            dataUri: '',
                            gender: pet.dataset.gender,
                            petPossessive: pet.dataset.petPossessive,
                            noImage: false,
                        };
                        const backgroundImage = pet.dataset.photoUrl;
                        if (backgroundImage === "None") {
                            petData[id].image = {href: UPLOAD_PHOTO_ICON}
                            petData[id].dataUri = UPLOAD_PHOTO_ICON;
                            petData[id].noImage = true;
                        } else {
                            petData[id].image = {href: backgroundImage};
                            petData[id].dataUri = backgroundImage;
                        }
                    });
                    return petData;
                }

                function getLanguage() {
                    return document.querySelector('#language').value;
                }

                function setPetImage(pet_id, url) {
                    const cacheBust = () => `?${Math.random()}`;
                    const roundals = document.querySelectorAll(`.tutorial-space-pet-roundal[data-pet-id="${pet_id}"]`);
                    roundals.forEach(roundal => {
                        roundal.style.backgroundImage = `url("${url}${cacheBust()}")`;
                        roundal.style.backgroundPosition = 'center center';
                        roundal.style.backgroundSize = 'cover';
                        // Clear tongue svg
                        const tongueSvg = roundal.querySelector('.tutorial-space-tongue');
                        if (tongueSvg !== null) {
                            tongueSvg.remove();
                        }
                    });

                    // Update the DOM data store
                    const query = `#tutorial-space-pet-data .pet-data[data-pet-id="${pet_id}"]`;
                    const elem = document.querySelector(query);
                    if (elem) {
                        elem.dataset.photoUrl = `${url}${cacheBust()}`;
                    }
                }

                function getLocalState() {
                    return {
                        seenGettingStarted:
                            localStorage.getItem(MTI_SEEN_GETTING_STARTED) || false,
                        seenAddPhoto:
                            localStorage.getItem(MTI_SEEN_ADD_PHOTO) || false,
                        seenLearnHow:
                            localStorage.getItem(MTI_SEEN_LEARN_HOW) || false,
                        seenMakeChanges:
                            localStorage.getItem(MTI_SEEN_MAKE_CHANGES) || false,
                        seenDigestion:
                            localStorage.getItem(MTI_SEEN_DIGESTION) || false,
                        seenSkinCoat:
                            localStorage.getItem(MTI_SEEN_SKIN_COAT) || false,
                        seenJoints:
                            localStorage.getItem(MTI_SEEN_JOINTS) || false,
                        tickIconSVG: tickIconSVG,
                        seenPrompt:
                            localStorage.getItem(MTI_SEEN_PROMPT) || false,
                    }
                }

                const tickIconSVG = `
<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg">
 <g>
  <rect x="-1" y="-1" width="42" height="42" id="canvas_background" fill="none"/>
 </g>
 <g>
  <ellipse stroke="null" ry="19.70366" rx="19.70366" id="svg_1" cy="19.94626" cx="19.99313" stroke-opacity="null" stroke-width="null" fill="#bdbefd"/>
  <path stroke="null" fill="#061f0a" d="m16.96501,28.18126c-0.17401,0.00099 -0.34124,-0.06732 -0.46478,-0.18986l-5.89151,-5.89151c-0.25667,-0.2567 -0.25667,-0.67287 0,-0.92956s0.67287,-0.2567 0.92953,0l5.38089,5.38092l11.32479,-13.83849c0.13779,-0.20824 0.38206,-0.31998 0.62974,-0.28799s0.45558,0.20207 0.53596,0.43847c0.08039,0.23643 0.01924,0.49799 -0.15758,0.6743l-11.78301,14.40146c-0.11593,0.14355 -0.28709,0.23151 -0.4713,0.24222l-0.03273,0l0,0.00003l0.00001,-0.00001z" id="svg_70" stroke-width="0"/>
 </g>
</svg>
`;

                const rightChevronSVG = `
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
<title></title>
<path fill="#000" d="M137.945 512.008c-5.234 0.030-10.265-2.025-13.981-5.711-3.728-3.697-5.825-8.731-5.825-13.981s2.097-10.284 5.825-13.981l222.326-222.326-222.326-222.326c-3.728-3.697-5.825-8.731-5.825-13.982s2.097-10.284 5.825-13.982c7.68-7.635 20.085-7.635 27.766 0l236.308 236.308c3.728 3.697 5.825 8.731 5.825 13.981s-2.097 10.284-5.825 13.981l-236.308 236.308c-3.668 3.638-8.619 5.689-13.785 5.711z"></path>
</svg>
`;

                const rightArrowSVG = `
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="768" height="768" viewBox="0 0 768 768">
<title></title>
<path fill="#2f7f70" d="M640 352h-389.44l178.72-178.72-45.28-45.28-256 256 256 256 45.28-45.28-178.72-178.72h389.44v-64z"></path>
</svg>
`;

                function loadHat() {
                    const hatIconSVG = `
    <!--
     * Font Awesome Free 5.13.0 by @fontawesome - https://fontawesome.com
     * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
    -->
    <svg id="mti-experiments-hat-icon" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="graduation-cap" class="svg-inline--fa fa-graduation-cap fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"></path></svg>
    `;

                    // Add hat icon
                    const hatPlaceholder = document.querySelector('.mti-experiments-hat-placeholder');
                    if (hatPlaceholder === null) {
                        return
                    }

                    const hatIcon = document.createElement('div');
                    hatIcon.innerHTML = hatIconSVG;
                    hatPlaceholder.insertAdjacentElement('beforebegin', hatIcon);

                    // Add notificationDot if we've not seen everything yet
                    if (![getLocalState().seenAddPhoto, getLocalState().seenLearnHow, getLocalState().seenMakeChanges].every((elem) => {
                        return elem
                    })) {
                        const notificationDot = document.createElement('div');
                        notificationDot.setAttribute('class', 'mti-experiments-notification-dot');
                        hatPlaceholder.insertAdjacentElement('beforebegin', notificationDot);
                    }

                    let popperInstance = null;
                    const tooltip = document.createElement('div');
                    tooltip.setAttribute('id', 'mti-experiments-tooltip');
                    tooltip.setAttribute('role', 'tooltip');
                    const tooltipQuery = document.querySelector('#tutorial-space-tooltip');
                    if (!tooltipQuery) {
                        return
                    }

                    // Insert a break roughly halfway through the string
                    let tooltipContent = tooltipQuery.innerText;
                    for (let i = parseInt(tooltipContent.length / 2); i > 0; i--) {
                        if (tooltipContent[i] === ' ') {
                            tooltipContent = tooltipContent.split('');
                            tooltipContent[i] = '<br/>';
                            tooltipContent = tooltipContent.join('');
                            break
                        }
                    }

                    tooltip.innerHTML = `<div style="margin: 6px;">${tooltipContent}</div>
        <div id="arrow" data-popper-arrow></div>`;
                    hatPlaceholder.insertAdjacentElement('beforebegin', tooltip);

                    function showTooltip() {
                        tooltip.setAttribute('data-show', '');
                        popperInstance = createPopper(
                            document.getElementById('mti-experiments-hat-icon'),
                            document.getElementById('mti-experiments-tooltip'),
                            {
                                placement: 'bottom-end'
                            }
                        )
                    }

                    function hideTooltip() {
                        tooltip.removeAttribute('data-show');
                        if (popperInstance) {
                            popperInstance.destroy();
                            popperInstance = null;
                        }
                    }

                    const showEvents = ['mouseenter', 'focus'];
                    const hideEvents = ['mouseleave', 'blur'];

                    showEvents.forEach(event => {
                        hatIcon.addEventListener(event, showTooltip);
                    });

                    hideEvents.forEach(event => {
                        hatIcon.addEventListener(event, hideTooltip);
                    });

                    return hatIcon;
                }

                function loadComponents() {
                    const root = document.createElement("div");
                    const root_el = "tutorial-space-root";
                    root.id = root_el;
                    document.body.appendChild(root);

                    Vue.component("Prompt", {
                        methods: {
                            nextStep: function (step) {
                                this.$emit("next-step", step);
                            }
                        },
                        mounted() {
                            localStorage.setItem(MTI_SEEN_PROMPT, true);
                        },
                        template: document.querySelector('#tutorial-space-prompt').innerHTML
                    });

                    Vue.component("GettingStarted", {
                        props: {
                            experiment: String
                        },
                        data: function () {
                            return {...getLocalState(), ...getPetData(), thisPet: currentPetPossessives(), isThereAnExperiment: experiments && experiments.dataset.experiment, rightChevronSVG: rightChevronSVG}
                        },
                        methods: {
                            nextStep: function (step) {
                                this.$emit("next-step", step);
                            }
                        },
                        template: document.querySelector('#tutorial-space-getting-started').innerHTML
                    });

                    Vue.component("AddPhoto", {
                        data: function () {
                            return {
                                croppa: {},
                                petData: getPetData(),
                                rightArrowSVG: rightArrowSVG,
                                rightChevronSVG: rightChevronSVG,
                                isThereAnExperimentNextStep: experiments && experiments.dataset.experiment,
                                thisPet: currentPetPossessives(),
                                placeholder: UPLOAD_PHOTO_ICON
                            };
                        },
                        methods: {
                            nextStep: function (step) {
                                this.$emit("next-step", step);
                            },
                            handleChoose: function (pet_id) {
                                if (this.$refs[pet_id]) {
                                    this.$refs[pet_id][0].chooseFile();
                                }
                            },
                            upload: function (pet_id) {
                                this.petData[pet_id].dataUri = this.$refs[pet_id][0].generateDataUrl();
                                this.$refs[pet_id][0].generateBlob(
                                    blob => {
                                        const formData = new FormData();
                                        formData.append('photo', blob);
                                        const options = {
                                            method: 'POST',
                                            body: formData,
                                        };
                                        fetch(`${PET_UPLOAD}/${pet_id}`, options)
                                            .then(res => {
                                                return res.json();
                                            })
                                            .then(json => {
                                                if (json.success === true) {
                                                    this.petData[pet_id].image.href = json.url;
                                                    this.petData[pet_id].dataUri = '';
                                                    this.petData[pet_id].noImage = false;

                                                    // Change the DOM underneath and the DOM data store
                                                    setPetImage(pet_id, json.url);

                                                    // Update application state
                                                    this.petData = getPetData();
                                                    return
                                                }
                                                console.log('error uploading', json);
                                            })
                                    },
                                    "image/jpeg",
                                    1.0
                                );
                            }
                        },
                        template: document.querySelector('#tutorial-space-add-photo').innerHTML
                    });

                    Vue.component("LearnHow", {
                        data: function () {
                            return {rightChevronSVG: rightChevronSVG, rightArrowSVG: rightArrowSVG, thisPet: currentPetPossessives(), language: getLanguage()};
                        },
                        methods: {
                            nextStep: function (step) {
                                this.$emit("next-step", step);
                            },
                            getBlogURL(language) {
                                const urlMap = {
                                    'en_GB': 'https://help.tails.com/hc/en-gb/articles/360011375618-How-do-I-change-the-flavour-of-my-dog-s-tails-com-recipe-',
                                    'fr_FR': 'https://help.tails.com/hc/fr/articles/360003229617-Puis-je-changer-le-go%C3%BBt-de-sa-recette-tails-com-',
                                    'de_DE': 'https://help.tails.com/hc/de/articles/360005527357-Kann-ich-die-Geschmacksrichtung-des-Futters-%C3%A4ndern-das-mein-Hund-von-tails-com-bekommt-',
                                }
                                return urlMap[language] ? urlMap[language] : null;
                            }
                        },
                        template: document.querySelector('#tutorial-space-learn-how').innerHTML
                    });

                    Vue.component("MakeChanges", {
                        props: {
                            experiment: String
                        },
                        data: function () {
                            return {rightChevronSVG: rightChevronSVG, rightArrowSVG: rightArrowSVG, thisPet: currentPetPossessives()};
                        },
                        methods: {
                            nextStep: function (step) {
                                this.$emit("next-step", step);
                            },
                            isCurrentPet: function (attributePetID) {
                                if (attributePetID.toString() === getCurrentPet()) {
                                    return true;
                                }
                                return false;
                            }
                        },
                        template: document.querySelector('#tutorial-space-make-changes').innerHTML
                    });

                    Vue.component("Digestion", {
                        data: function () {
                            return {rightChevronSVG: rightChevronSVG, rightArrowSVG: rightArrowSVG, thisPet: currentPetPossessives()};
                        },
                        methods: {
                            nextStep: function (step) {
                                this.$emit("next-step", step);
                            }
                        },
                        template: document.querySelector('#tutorial-space-personalised-digestion').innerHTML
                    });

                    Vue.component("SkinCoat", {
                        data: function () {
                            return {rightChevronSVG: rightChevronSVG, rightArrowSVG: rightArrowSVG, thisPet: currentPetPossessives()};
                        },
                        methods: {
                            nextStep: function (step) {
                                this.$emit("next-step", step);
                            }
                        },
                        template: document.querySelector('#tutorial-space-personalised-skin-coat').innerHTML
                    });

                    Vue.component("Joints", {
                        data: function () {
                            return {rightChevronSVG: rightChevronSVG, rightArrowSVG: rightArrowSVG, thisPet: currentPetPossessives()};
                        },
                        methods: {
                            nextStep: function (step) {
                                this.$emit("next-step", step);
                            }
                        },
                        template: document.querySelector('#tutorial-space-personalised-joints').innerHTML
                    });

                    let version = 1;
                    const data = document.querySelector('#tutorial-space-data');
                    if (data) {
                        version = Number(data.dataset.version);
                    }

                    const rootTemplates = (type) => {
                        const components = {
                            default: '',
                            digestion: `<Digestion v-if="digestion" v-on:next-step="handleStep"/>`,
                            skin_coat: `<SkinCoat v-if="skin_coat" v-on:next-step="handleStep"/>`,
                            joints: `<Joints v-if="joints" v-on:next-step="handleStep"/>`,
                        };
                        return `
                        <div v-if="open" class="getting-started-container ${version === 2 ? 'tutorial-space-v2' : ''}"
                             v-on:click="handleStep('close')">
                            <div class="getting-started-inner" v-on:click.stop="">
                                <Prompt v-if="prompt" v-on:next-step="handleStep"/>
                                <GettingStarted v-if="gettingStarted" v-on:next-step="handleStep" :experiment="experiment"/>
                                <AddPhoto v-if="addPhoto" v-on:next-step="handleStep"/>
                                <MakeChanges v-if="makeChanges" v-on:next-step="handleStep" :experiment="experiment"/>
                                <LearnHow v-if="learnHow" v-on:next-step="handleStep"/>
                                ${components[type]}
                            </div>
                        </div>`;
                    };

                    let rootTemplate = rootTemplates('default');

                    // Handle experiments
                    let experiment = null;
                    const experiments = document.querySelector('#tutorial-space-experiments');
                    if (experiments && experiments.dataset.experiment) {
                        experiment = experiments.dataset.experiment;
                        rootTemplate = rootTemplates(experiment)
                    }

                    const vm = new Vue({
                        el: `#${root_el}`,
                        data() {
                            return {
                                open: !getLocalState().seenPrompt && !getLocalState().seenGettingStarted,
                                // Instead of the prompt, Version 2 goes straight to Getting Started
                                prompt: version !== 2,
                                gettingStarted: version === 2,
                                addPhoto: false,
                                makeChanges: false,
                                learnHow: false,
                                orientationChanged: false,
                                // Experiments
                                experiment: experiment,
                                digestion: false,
                                skin_coat: false,
                                joints: false,
                            }
                        },
                        methods: {
                            reset: function () {
                                this.open = true;
                                this.prompt = false;
                                this.gettingStarted = false;
                                this.addPhoto = false;
                                this.makeChanges = false;
                                this.learnHow = false;

                                // Experiments
                                this.digestion = false;
                                this.skin_coat = false;
                                this.joints = false;
                            },
                            fixBehindScrolling: function () {
                                document.body.style.position = 'fixed';
                                document.body.style.top = `-${window.scrollY}px`;
                            },
                            releaseBehindScrolling: function () {
                                const scrollY = document.body.style.top;
                                document.body.style.position = '';
                                document.body.style.top = '';
                                window.scrollTo(0, parseInt(scrollY || '0') * -1);
                            },
                            handleStep: function (step) {
                                this.reset();
                                if (step === "start") {
                                    this.prompt = true;
                                } else if (step === "close") {
                                    if (this.orientationChanged === true) {
                                        location.reload();
                                    } else {
                                        this.open = false;
                                        this.releaseBehindScrolling();
                                        // tidy up width fix
                                        const widthfixedSlickDotsPanes = document.querySelectorAll(".width-fix");
                                        widthfixedSlickDotsPanes.forEach((pane) => {
                                            if (pane.removeClass) {
                                                pane.removeClass("width-fix");
                                            }
                                        })
                                    }
                                } else if (step === "gettingStarted") {
                                    this.gettingStarted = true;
                                    this.fixBehindScrolling();
                                    localStorage.setItem(MTI_SEEN_GETTING_STARTED, true);
                                } else if (step === "addPhoto") {
                                    this.addPhoto = true;
                                    localStorage.setItem(MTI_SEEN_ADD_PHOTO, true);
                                } else if (step === "makeChanges") {
                                    this.makeChanges = true;
                                    localStorage.setItem(MTI_SEEN_MAKE_CHANGES, true);
                                } else if (step === "learnHow") {
                                    this.learnHow = true;
                                    localStorage.setItem(MTI_SEEN_LEARN_HOW, true);
                                } else if (step === "afterAddPhoto") {
                                    // will either be the experiment, else, Learn How
                                    if (experiments && experiments.dataset.experiment) {
                                        if (experiments.dataset.experiment === 'digestion') {
                                            this.digestion = true;
                                            localStorage.setItem(MTI_SEEN_DIGESTION, true);
                                        } else if (experiments.dataset.experiment === 'skin_coat') {
                                            this.skin_coat = true;
                                            localStorage.setItem(MTI_SEEN_SKIN_COAT, true);
                                        } else if (experiments.dataset.experiment === 'joints') {
                                            this.joints = true;
                                            localStorage.setItem(MTI_SEEN_JOINTS, true);
                                        }
                                    } else {
                                        this.learnHow = true;
                                        localStorage.setItem(MTI_SEEN_LEARN_HOW, true);
                                    }
                                }

                                // Handle direct views (from top-level step list not CTAs)
                                if (step === 'digestion') {
                                    this.digestion = true;
                                    localStorage.setItem(MTI_SEEN_DIGESTION, true);
                                } else if (step === 'skin_coat') {
                                    this.skin_coat = true;
                                    localStorage.setItem(MTI_SEEN_SKIN_COAT, true);
                                } else if (step === 'joints') {
                                    this.joints = true;
                                    localStorage.setItem(MTI_SEEN_JOINTS, true);
                                }

                                // Remove dot if we've seen all the things
                                if (getLocalState().seenAddPhoto &&
                                    getLocalState().seenLearnHow &&
                                    getLocalState().seenMakeChanges) {
                                    if (!experiment) {
                                        const notificationDot = document.getElementsByClassName("mti-experiments-notification-dot")[0];
                                        if (notificationDot) {
                                                    notificationDot.style.display = "none";
                                        }
                                    } else {
                                        // Experiments
                                        if (localStorage.getItem(MTI_SEEN_DIGESTION) ||
                                            localStorage.getItem(MTI_SEEN_SKIN_COAT) ||
                                            localStorage.getItem(MTI_SEEN_JOINTS)) {
                                            const notificationDot = document.getElementsByClassName("mti-experiments-notification-dot")[0];
                                                if (notificationDot) {
                                                    notificationDot.style.display = "none";
                                                }
                                        }
                                    }
                                }

                                // Hack for scrolling to the top of the steps
                                document.querySelectorAll(".getting-started-container > div").forEach(div => div.scrollTop = 0);
                            },
                            hat: function () {
                                this.handleStep("gettingStarted");
                            },
                            handleOrientationChange: function () {
                                this.orientationChanged = true;
                            },
                            handleWindowResized: function () {
                                // Manually set the width to 100vw with CSS class because slickdots is misbehaving
                                const bgActiveSlickdotsPane = document.querySelector(".pet.selected.slick-slide.slick-current.slick-active");
                                if (bgActiveSlickdotsPane !== null) {
                                    bgActiveSlickdotsPane.classList.add("width-fix");
                                }
                                const bgActiveSlickdotsProfileWrapper = document.querySelector(".pets-wrapper.tails-view.tails-view-pet-profiles.slick-initialized.slick-slider");
                                if (bgActiveSlickdotsProfileWrapper !== null) {
                                    bgActiveSlickdotsProfileWrapper.classList.add("width-fix");
                                }
                            }
                        },
                        mounted() {
                            this.handleWindowResized();
                            if (this.open === true) {
                                this.fixBehindScrolling();
                            }
                            window.addEventListener(
                                "orientationchange", this.handleOrientationChange
                            );
                            window.addEventListener(
                                'resize', this.handleWindowResized
                            )
                        },
                        template: rootTemplate
                    });

                    const hatIcon = loadHat();
                    hatIcon.addEventListener("click", () => vm.$root.hat());
                }

                loadComponents();
            }
        }
    );

    t.controllers.define(
        'christmas-product',
        {
            'click .plus': 'plus',
            'click .minus': 'minus',
            'click .save': 'save',
        },
        {
            'init:after': function () {
                this.units = this.$el.find('[name="quantity"]');
                this.carouselArrowCursor = 0;
                const carouselMain = this.$el.find('.product-image');
                this.carouselItems = this.$el.find('.thumbnail-product-image').toArray();
                const initialImage = this.$el.find('.product-image').css('backgroundImage');
                const thumbnailBar = this.$el.find('.thumbnail-images');

                this.$el.find('.arrow-left').click(() => {
                    this.carouselArrowCursor = Math.max(0, this.carouselArrowCursor - 1);
                    this.carouselRender()
                });
                this.$el.find('.arrow-right').click(() => {
                    this.carouselArrowCursor = Math.min(this.carouselItems.length - 3, this.carouselArrowCursor + 1);
                    this.carouselRender()
                });

                thumbnailBar.addClass('gradient');

                const swapItem = element => {
                    const target = $(element.target);
                    // Swap image
                    carouselMain.css('background-image', `url(${target.attr('src')})`);
                    // Toggle active highlight
                    this.$el.find('.selected').removeClass('selected');
                    target.addClass('selected');

                    thumbnailBar.toggleClass('gradient', carouselMain.css('backgroundImage') === initialImage);
                };
                this.$el.find('.thumbnail-product-image').each(function () {
                    // Images selected on click or hover (just click on mobile obviously)
                    $(this).on('click mouseover', element => swapItem(element));
                });

                this.carouselRender();
            },
            carouselRender: function() {
                const rightArrow = this.$el.find('.arrow-right');
                const leftArrow = this.$el.find('.arrow-left');

                leftArrow.addClass('active');
                rightArrow.addClass('active');

                if (this.carouselArrowCursor === 0) {
                    leftArrow.removeClass('active');
                }
                if (this.carouselArrowCursor === this.carouselItems.length - 3) {
                    rightArrow.removeClass('active');
                }

                this.carouselItems.forEach((item, i) => {
                    if (i >= this.carouselArrowCursor && i < this.carouselArrowCursor + 3 ) {
                        item.classList.remove('hide')
                    } else {
                        item.classList.add('hide')
                    }
                })
            },
            plus: function (e) {
                const current = parseInt(this.units.val());
                this.units.val(current + 1);
                e.preventDefault();
            },
            minus: function (e) {
                const current = parseInt(this.units.val());
                this.units.val(Math.max(0, current - 1));
                e.preventDefault();
            },
            save: function (e) {
                const btn = this.$el.find('.save');
                btn.attr('disabled', true).addClass('btn-progress');
                btn.closest('form').submit();
            }
        }
    );

    t.controllers.define(
        'raf-banner-experiment',
        {
            'click .raf-banner-cta': 'onBannerClick',
        },
        {
            optimizelyTrackApi: function(event) {
                $.ajax({
                    type: 'GET',
                    url: '/api/optimizely/track/?event=' + event,
                    dataType: 'json',
                    success: (response) => {},
                });
            },
            onBannerClick: function() {
                this.optimizelyTrackApi('clicked_banner_cta');
            }
        }
    );

    t.controllers.define(
        'wet-food-info-toggle',
        // Wet food more information content block on reactivation_details.html
        {
            'click #wet-food-info-cta-open': 'onOpenClick',
            'click #wet-food-info-cta-close': 'onCloseClick',
        },
        {
            onOpenClick: function () {
                const moreInformationText = document.querySelector('#wet-food-info-text');
                const openButton = document.querySelector('#wet-food-info-cta-open');
                const closeButton = document.querySelector('#wet-food-info-cta-close');
                const header = document.querySelector('.wet-food-info-card .header')

                // Display information about ordering wet food and change the clickable chevron
                openButton.classList.add('hidden');
                closeButton.classList.remove('hidden');
                moreInformationText.classList.remove('hidden');
                header.classList.add('expand');
            },
            onCloseClick: function () {
                const moreInformationText = document.querySelector('#wet-food-info-text');
                const openButton = document.querySelector('#wet-food-info-cta-open');
                const closeButton = document.querySelector('#wet-food-info-cta-close');
                const header = document.querySelector('.wet-food-info-card .header')

                // Hide information about ordering wet food and change the clickable chevron
                closeButton.classList.add('hidden');
                openButton.classList.remove('hidden');
                moreInformationText.classList.add('hidden');
                header.classList.remove('expand');
            },
        }
    );

    t.controllers.define(
        'show-more-less-toggle',
        {
            'click #show-more-attributes': 'onShowMoreClick',
            'click #show-less-attributes': 'onShowLessClick',
        },
        {
            onShowMoreClick: function () {
                const profile = document.querySelector('#collapsible-pet-profile');
                const showMore = document.querySelector('#show-more-attributes');
                const showLess = document.querySelector('#show-less-attributes');

                showMore.classList.add('hidden');
                showLess.classList.remove('hidden');
                profile.classList.remove('collapsed');
            },
            onShowLessClick: function () {
                const profile = document.querySelector('#collapsible-pet-profile');
                const showMore = document.querySelector('#show-more-attributes');
                const showLess = document.querySelector('#show-less-attributes');

                showLess.classList.add('hidden');
                showMore.classList.remove('hidden');
                profile.classList.add('collapsed');
            },
        }
    );

    t.controllers.define(
        'reactivation-delivery-date',
        {
            'change .future-delivery-dropdown select': 'onDeliveryDateClick',
            'click #delivery-window': 'onDeliveryWindowClick',
            'click #delivery-asap': 'onDeliveryASAPClick',
            'click button[type="submit"]': 'submitReactivation',
        },
        {
            'init:after': function () {
                // Retain old ASAP payment date as a data attribute
                const paymentDateElem = document.querySelector('#payment-date');
                paymentDateElem.dataset.oldASAPPaymentDate = paymentDateElem.innerHTML;
            },
            onDeliveryDateClick: function (event) {
                // Update the "Your payment will be taken on X element"
                // when the user selects a new delivery date
                // with the new corresponding billing date.

                const deliveryWindowID = event.currentTarget.value;
                const deliveryWindowBillingMap = document.querySelector('#delivery-window-billing-date-map');
                const billingDateElem = deliveryWindowBillingMap.querySelector("div[data-id='"+deliveryWindowID+"']");
                const paymentDateElem = document.querySelector('#payment-date');
                paymentDateElem.innerHTML = billingDateElem.innerHTML;
            },
            // There are two buttons in the DOM which submit the delivery form:
            // one merges shipments together, while the other submits a specific date.
            // We need to show/hide the relevant buttons when a user selects
            // to receive the new shipment with the existing one, or on a specific date
            onDeliveryWindowClick: function () {
                const dropdown = document.querySelector('#future-delivery-dropdown');
                dropdown.classList.remove('hidden');

                // Hide merge button, show specific date button
                const submitSpecific = document.querySelector('#specific-date-confirm');
                submitSpecific.classList.remove('hidden');
                submitSpecific.style.display = 'block';

                const submitMerge = document.querySelector('#merge-confirm');
                submitMerge.classList.add('hidden');

                // Get the old selected delivery window's payment data from data atrribute, if it exists
                const paymentDateElem = document.querySelector('#payment-date');
                if (paymentDateElem.dataset.oldSelectedPaymentDate !== undefined) {
                    paymentDateElem.innerHTML = paymentDateElem.dataset.oldSelectedPaymentDate;
                } else {
                    // Update billing date to the one associated with the first delivery window in list
                    const deliveryWindowID = Array.from(document.getElementById('dates').children).filter((el) => {
                        return el.attributes.getNamedItem('selected') != null;
                    })[0].attributes.value.value;
                    const deliveryWindowBillingMap = document.querySelector('#delivery-window-billing-date-map');
                    const billingDateElem = deliveryWindowBillingMap.querySelector("div[data-id='"+deliveryWindowID+"']");
                    paymentDateElem.innerHTML = billingDateElem.innerHTML;
                }
            },
            onDeliveryASAPClick: function () {
                // Hide specific date button, show merge button
                const dropdown = document.querySelector('#future-delivery-dropdown');
                dropdown.classList.add('hidden');

                const submitSpecific = document.querySelector('#specific-date-confirm');
                submitSpecific.classList.add('hidden');

                const submitMerge = document.querySelector('#merge-confirm');
                submitMerge.classList.remove('hidden');

                // Remember old selected date's payment date as data atrribute
                const paymentDateElem = document.querySelector('#payment-date');
                paymentDateElem.dataset.oldSelectedPaymentDate = paymentDateElem.innerHTML;

                // Restore original billing date stored as data attribute on init
                paymentDateElem.innerHTML = paymentDateElem.dataset.oldASAPPaymentDate;
            },
            submitReactivation: function (event) {
                if (event.currentTarget.classList.contains("link-progress")) {
                  event.preventDefault();
                } else {
                  event.currentTarget.classList.add("link-progress");
                }
            },
        }
    );

    t.controllers.define(
        "reactivation-buttons",
        {
        "click #reactivation-next-button": "addLoadingAnimationClass",
        },
        {
        addLoadingAnimationClass: function (event) {
            document
              .getElementById("reactivation-next-button")
              .classList.add("link-progress");
        },
        }
    );

    t.controllers.define(
        'offboarding-tiles',
        // Small helper to watch for custom Emarsys-injected DOM elements
        // and reposition offboarding tiles accordingly.
        {},
        {
            'init:after': function () {
                function repositionOffboardingTiles() {
                    const staticContainer = document.getElementsByClassName('offboarding-cards-container')[0];
                    if (staticContainer !== undefined) {
                        const emarsysContainers = ['1', '2', '3', '4'].map((i) => {
                            return document.getElementsByName(`emarsys-custom-content-${i}`)[0];
                        });
                        let emarsysCards = [];
                        emarsysContainers.forEach((el) => {
                            if (Array.from(el.children).length) {
                                emarsysCards.push(el);
                            }
                        });

                        // Add/remove class to ensure content card is centred if only one present on page
                        const staticCards = Array.from(staticContainer.children).filter((el) => {
                            return el.classList.contains('offboarding-solution-card');
                        });
                        const totalCards = staticCards.length + emarsysCards.length;

                        if (totalCards === 1) {
                            staticContainer.classList.add('offboarding-solution-card-container-single');
                        } else if (totalCards > 1) {
                            staticContainer.classList.remove('offboarding-solution-card-container-single');
                        }

                        // On the food issue page: make first static card full-width if no Emarsys content injected in
                        // the top/first content zone
                        const emarsysContainerFoodIssueTop = document.getElementById(
                            'emarsys-custom-cancellation-component-food-issue-4'
                        );
                        const staticContainerFoodIssue = document.getElementById('food-issue-card');
                        if (emarsysContainerFoodIssueTop && emarsysContainerFoodIssueTop.childNodes &&
                            (emarsysContainerFoodIssueTop.childNodes.length >  0)) {
                            staticContainerFoodIssue.classList.remove('change-food');
                        }
                    }
                }
                repositionOffboardingTiles();
                window.addEventListener('EmarsysContentLoaded', function(event) {
                    repositionOffboardingTiles();
                }, false);
            },
        }
    );


    t.controllers.define(
        'treatment',
        {
            'init:after': function () {
                let backUrl = '/gb/pets'
                const referrer = new URLSearchParams(window.location.search).get('referrer') || document.referrer
                // only allow referrer to be within our domain, but prevent any potential looping happening
                if (referrer && referrer.startsWith(window.location.origin) && !referrer.startsWith(window.location.origin + window.location.pathname)) {
                    backUrl = referrer
                }
                this.$el.find('.back-button').attr('href', backUrl)
                this.carouselArrowCursor = 0;
                const carouselMain = this.$el.find('.product-image');
                this.carouselItems = this.$el.find('.thumbnail-product-image').toArray();
                const initialImage = this.$el.find('.product-image').css('backgroundImage');
                const thumbnailBar = this.$el.find('.thumbnail-images');
                this.maxThumbnails = window.innerWidth < 992 ? 3 : 5
                $(window).on('resize', () => {
                    this.maxThumbnails = window.innerWidth < 992 ? 3: 5;
                    this.carouselRender()
                })

                const notification = this.$el.find('.notification');
                setTimeout(function () {
                    notification.fadeOut(300, function () {
                        notification.remove();
                    });
                }, 10000);

                this.$el.find('.arrow-left').click(() => {
                    const nextIndex = this.carouselArrowCursor - 1
                    if (nextIndex < 0) return
                    swapItem(this.carouselItems[nextIndex], nextIndex)
                });
                this.$el.find('.arrow-right').click(() => {
                    const nextIndex = this.carouselArrowCursor + 1
                    if (nextIndex> this.carouselItems.length - 1) return
                    swapItem(this.carouselItems[nextIndex], nextIndex)
                });

                const swapItem = (element, index) => {
                    const target = $(element);
                    // Swap image
                    carouselMain.css('background-image', `url(${target.attr('src')})`);
                    // Toggle active highlight
                    this.carouselArrowCursor = index
                    this.$el.find('.selected').removeClass('selected');
                    target.addClass('selected');
                    this.carouselRender()
                };
                this.$el.find('.thumbnail-product-image').each(function (i) {
                    // Images selected on click or hover (just click on mobile obviously)
                    $(this).on('click', element => swapItem(element.target, i));
                });

                this.carouselRender();
            },
            carouselRender: function () {
                const rightArrow = this.$el.find('.arrow-right');
                const leftArrow = this.$el.find('.arrow-left');

                leftArrow.addClass('active');
                rightArrow.addClass('active');

                if (this.carouselArrowCursor === 0) {
                    leftArrow.removeClass('active');
                }
                if (this.carouselArrowCursor === this.carouselItems.length - 1) {
                    rightArrow.removeClass('active');
                }
                this.carouselItems.forEach((item, i) => {
                    if (
                        // this only takes into account 2 pages of the thumbnails but you know what
                        // it doesn't matter because we're going to move this to the shop in the future
                        // where the carousel is perfect and i am tired of trying to make this work
                        // please don't add more images... or else
                        this.carouselArrowCursor < this.maxThumbnails && i < this.maxThumbnails ||
                        this.carouselArrowCursor >= this.maxThumbnails && i >= this.carouselItems.length - this.maxThumbnails
                    ) {
                        item.classList.remove('hide');
                    } else {
                        item.classList.add('hide');
                    }
                })
            },
        }
    );



})($, window.tails);

(function addXhrProgressEvent($) {
    var originalXhr = $.ajaxSettings.xhr;
    $.ajaxSetup({
        progress: function() { console.log("standard progress callback"); },
        xhr: function() {
            var req = originalXhr(), that = this;
            if (req) {
                if (typeof req.addEventListener == "function") {
                    req.addEventListener("progress", function(evt) {
                        that.progress(evt);
                    },false);
                }
            }
            return req;
        }
    });
})($);
